import { generateRandomCode } from './utils';
/**
 * Life Expectancy Calculator - TypeScript Implementation
 * Migrated from JavaScript to TypeScript for React
 */

// Types
export interface FormData {
    // pilotCode: string | undefined;
    gender: 'female' | 'male';
    age: number;
    smoking: 'yes' | 'no';
    systolic: number;
    cholesterol: number;
}

export interface Intervention {
    name: string;
    years: number;
    type: 'smoking' | 'systolic' | 'cholesterol';
}

export interface CalculationResult {

    pilotCode?: string;
    success: boolean;
    interventions: Intervention[];
    results?: {
        smokeYears: number;
        systolicYears: number;
        cholesterolYears: number;
    };
    total_years: number;
    input_data: FormData;
    error?: string;
    resultIdentifier?: string
    resultIdentifierDisplay?: string;
}

// Calculation dictionaries - extracted from Python app.py
const calcSmoke: Record<string, number> = {
    // Women smoking calculations
    'Women_90+_160-179_<150': 0.8
    , 'Women_90+_160-179_150-200': 0.8
    , 'Women_90+_160-179_200-250': 0.9
    , 'Women_90+_160-179_250<': 0.9

    , 'Women_90+_140-159_<150': 0.8
    , 'Women_90+_140-159_150-200': 0.8
    , 'Women_90+_140-159_200-250': 0.8
    , 'Women_90+_140-159_250<': 0.8

    , 'Women_90+_120-139_<150': 0.8
    , 'Women_90+_120-139_150-200': 0.8
    , 'Women_90+_120-139_200-250': 0.8
    , 'Women_90+_120-139_250<': 0.8

    , 'Women_90+_100-119_<150': 0.8
    , 'Women_90+_100-119_150-200': 0.8
    , 'Women_90+_100-119_200-250': 0.8
    , 'Women_90+_100-119_250<': 0.8


    , 'Women_85-89_160-179_<150': 1.6
    , 'Women_85-89_160-179_150-200': 1.7
    , 'Women_85-89_160-179_200-250': 1.9
    , 'Women_85-89_160-179_250<': 1.9

    , 'Women_85-89_140-159_<150': 1.7
    , 'Women_85-89_140-159_150-200': 1.8
    , 'Women_85-89_140-159_200-250': 1.9
    , 'Women_85-89_140-159_250<': 1.9

    , 'Women_85-89_120-139_<150': 1.8
    , 'Women_85-89_120-139_150-200': 1.8
    , 'Women_85-89_120-139_200-250': 1.8
    , 'Women_85-89_120-139_250<': 1.8

    , 'Women_85-89_100-119_<150': 1.7
    , 'Women_85-89_100-119_150-200': 1.7
    , 'Women_85-89_100-119_200-250': 1.8
    , 'Women_85-89_100-119_250<': 1.8


    , 'Women_80-84_160-179_<150': 2.0
    , 'Women_80-84_160-179_150-200': 2.3
    , 'Women_80-84_160-179_200-250': 2.4
    , 'Women_80-84_160-179_250<': 2.4

    , 'Women_80-84_140-159_<150': 2.2
    , 'Women_80-84_140-159_150-200': 2.3
    , 'Women_80-84_140-159_200-250': 2.4
    , 'Women_80-84_140-159_250<': 2.5

    , 'Women_80-84_120-139_<150': 2.2
    , 'Women_80-84_120-139_150-200': 2.3
    , 'Women_80-84_120-139_200-250': 2.5
    , 'Women_80-84_120-139_250<': 2.5

    , 'Women_80-84_100-119_<150': 2.2
    , 'Women_80-84_100-119_150-200': 2.4
    , 'Women_80-84_100-119_200-250': 2.5
    , 'Women_80-84_100-119_250<': 2.5


    , 'Women_75-79_160-179_<150': 2.6
    , 'Women_75-79_160-179_150-200': 2.8
    , 'Women_75-79_160-179_200-250': 2.8
    , 'Women_75-79_160-179_250<': 2.9

    , 'Women_75-79_140-159_<150': 2.6
    , 'Women_75-79_140-159_150-200': 2.7
    , 'Women_75-79_140-159_200-250': 2.9
    , 'Women_75-79_140-159_250<': 3.0

    , 'Women_75-79_120-139_<150': 2.6
    , 'Women_75-79_120-139_150-200': 2.7
    , 'Women_75-79_120-139_200-250': 2.9
    , 'Women_75-79_120-139_250<': 3.0

    , 'Women_75-79_100-119_<150': 2.6
    , 'Women_75-79_100-119_150-200': 2.7
    , 'Women_75-79_100-119_200-250': 2.9
    , 'Women_75-79_100-119_250<': 3.0


    , 'Women_70-74_160-179_<150': 3.0
    , 'Women_70-74_160-179_150-200': 3.2
    , 'Women_70-74_160-179_200-250': 3.4
    , 'Women_70-74_160-179_250<': 3.4

    , 'Women_70-74_140-159_<150': 3.1
    , 'Women_70-74_140-159_150-200': 3.2
    , 'Women_70-74_140-159_200-250': 3.3
    , 'Women_70-74_140-159_250<': 3.4

    , 'Women_70-74_120-139_<150': 3.0
    , 'Women_70-74_120-139_150-200': 3.1
    , 'Women_70-74_120-139_200-250': 3.3
    , 'Women_70-74_120-139_250<': 3.4

    , 'Women_70-74_100-119_<150': 3.0
    , 'Women_70-74_100-119_150-200': 3.1
    , 'Women_70-74_100-119_200-250': 3.2
    , 'Women_70-74_100-119_250<': 3.3


    , 'Women_65-69_160-179_<150': 3.4
    , 'Women_65-69_160-179_150-200': 3.6
    , 'Women_65-69_160-179_200-250': 3.8
    , 'Women_65-69_160-179_250<': 3.9

    , 'Women_65-69_140-159_<150': 3.4
    , 'Women_65-69_140-159_150-200': 3.6
    , 'Women_65-69_140-159_200-250': 3.7
    , 'Women_65-69_140-159_250<': 3.8

    , 'Women_65-69_120-139_<150': 3.3
    , 'Women_65-69_120-139_150-200': 3.5
    , 'Women_65-69_120-139_200-250': 3.6
    , 'Women_65-69_120-139_250<': 3.7

    , 'Women_65-69_100-119_<150': 3.6
    , 'Women_65-69_100-119_150-200': 3.6
    , 'Women_65-69_100-119_200-250': 3.8
    , 'Women_65-69_100-119_250<': 3.9


    , 'Women_60-64_160-179_<150': 3.7
    , 'Women_60-64_160-179_150-200': 4.0
    , 'Women_60-64_160-179_200-250': 4.1
    , 'Women_60-64_160-179_250<': 4.3

    , 'Women_60-64_140-159_<150': 3.7
    , 'Women_60-64_140-159_150-200': 3.9
    , 'Women_60-64_140-159_200-250': 4.1
    , 'Women_60-64_140-159_250<': 4.2

    , 'Women_60-64_120-139_<150': 3.6
    , 'Women_60-64_120-139_150-200': 3.7
    , 'Women_60-64_120-139_200-250': 4.0
    , 'Women_60-64_120-139_250<': 4.0

    , 'Women_60-64_100-119_<150': 3.6
    , 'Women_60-64_100-119_150-200': 3.6
    , 'Women_60-64_100-119_200-250': 3.8
    , 'Women_60-64_100-119_250<': 3.9


    , 'Women_55-59_160-179_<150': 4.1
    , 'Women_55-59_160-179_150-200': 4.3
    , 'Women_55-59_160-179_200-250': 4.5
    , 'Women_55-59_160-179_250<': 4.6

    , 'Women_55-59_140-159_<150': 4.0
    , 'Women_55-59_140-159_150-200': 4.2
    , 'Women_55-59_140-159_200-250': 4.4
    , 'Women_55-59_140-159_250<': 4.5

    , 'Women_55-59_120-139_<150': 3.9
    , 'Women_55-59_120-139_150-200': 4.0
    , 'Women_55-59_120-139_200-250': 4.3
    , 'Women_55-59_120-139_250<': 4.3

    , 'Women_55-59_100-119_<150': 3.8
    , 'Women_55-59_100-119_150-200': 3.9
    , 'Women_55-59_100-119_200-250': 4.0
    , 'Women_55-59_100-119_250<': 4.1


    , 'Women_50-54_160-179_<150': 4.3
    , 'Women_50-54_160-179_150-200': 4.5
    , 'Women_50-54_160-179_200-250': 4.8
    , 'Women_50-54_160-179_250<': 4.9

    , 'Women_50-54_140-159_<150': 4.2
    , 'Women_50-54_140-159_150-200': 4.4
    , 'Women_50-54_140-159_200-250': 4.6
    , 'Women_50-54_140-159_250<': 4.7

    , 'Women_50-54_120-139_<150': 4.1
    , 'Women_50-54_120-139_150-200': 4.3
    , 'Women_50-54_120-139_200-250': 4.4
    , 'Women_50-54_120-139_250<': 4.5

    , 'Women_50-54_100-119_<150': 3.9
    , 'Women_50-54_100-119_150-200': 4.0
    , 'Women_50-54_100-119_200-250': 4.2
    , 'Women_50-54_100-119_250<': 4.3


    , 'Women_45-49_160-179_<150': 4.5
    , 'Women_45-49_160-179_150-200': 4.7
    , 'Women_45-49_160-179_200-250': 5.0
    , 'Women_45-49_160-179_250<': 5.1

    , 'Women_45-49_140-159_<150': 4.4
    , 'Women_45-49_140-159_150-200': 4.5
    , 'Women_45-49_140-159_200-250': 4.8
    , 'Women_45-49_140-159_250<': 4.9

    , 'Women_45-49_120-139_<150': 4.2
    , 'Women_45-49_120-139_150-200': 4.4
    , 'Women_45-49_120-139_200-250': 4.6
    , 'Women_45-49_120-139_250<': 4.7

    , 'Women_45-49_100-119_<150': 4.1
    , 'Women_45-49_100-119_150-200': 4.2
    , 'Women_45-49_100-119_200-250': 4.4
    , 'Women_45-49_100-119_250<': 4.5


    , 'Women_40-44_160-179_<150': 4.5
    , 'Women_40-44_160-179_150-200': 4.8
    , 'Women_40-44_160-179_200-250': 5.1
    , 'Women_40-44_160-179_250<': 5.2

    , 'Women_40-44_140-159_<150': 4.4
    , 'Women_40-44_140-159_150-200': 4.6
    , 'Women_40-44_140-159_200-250': 4.9
    , 'Women_40-44_140-159_250<': 5.0

    , 'Women_40-44_120-139_<150': 4.3
    , 'Women_40-44_120-139_150-200': 4.5
    , 'Women_40-44_120-139_200-250': 4.6
    , 'Women_40-44_120-139_250<': 4.8

    , 'Women_40-44_100-119_<150': 4.1
    , 'Women_40-44_100-119_150-200': 4.3
    , 'Women_40-44_100-119_200-250': 4.5
    , 'Women_40-44_100-119_250<': 4.5



    , 'Men_90+_160-179_<150': 0.5
    , 'Men_90+_160-179_150-200': 0.5
    , 'Men_90+_160-179_200-250': 0.5
    , 'Men_90+_160-179_250<': 0.6

    , 'Men_90+_140-159_<150': 0.5
    , 'Men_90+_140-159_150-200': 0.5
    , 'Men_90+_140-159_200-250': 0.6
    , 'Men_90+_140-159_250<': 0.6

    , 'Men_90+_120-139_<150': 0.5
    , 'Men_90+_120-139_150-200': 0.6
    , 'Men_90+_120-139_200-250': 0.6
    , 'Men_90+_120-139_250<': 0.7

    , 'Men_90+_100-119_<150': 0.5
    , 'Men_90+_100-119_150-200': 0.7
    , 'Men_90+_100-119_200-250': 0.7
    , 'Men_90+_100-119_250<': 0.7


    , 'Men_85-89_160-179_<150': 0.7
    , 'Men_85-89_160-179_150-200': 0.9
    , 'Men_85-89_160-179_200-250': 0.9
    , 'Men_85-89_160-179_250<': 1.0

    , 'Men_85-89_140-159_<150': 0.8
    , 'Men_85-89_140-159_150-200': 0.9
    , 'Men_85-89_140-159_200-250': 1.0
    , 'Men_85-89_140-159_250<': 1.0

    , 'Men_85-89_120-139_<150': 0.8
    , 'Men_85-89_120-139_150-200': 0.9
    , 'Men_85-89_120-139_200-250': 1.0
    , 'Men_85-89_120-139_250<': 1.1

    , 'Men_85-89_100-119_<150': 0.8
    , 'Men_85-89_100-119_150-200': 1.0
    , 'Men_85-89_100-119_200-250': 1.0
    , 'Men_85-89_100-119_250<': 1.1


    , 'Men_80-84_160-179_<150': 1.2
    , 'Men_80-84_160-179_150-200': 1.3
    , 'Men_80-84_160-179_200-250': 1.4
    , 'Men_80-84_160-179_250<': 1.4

    , 'Men_80-84_140-159_<150': 1.2
    , 'Men_80-84_140-159_150-200': 1.3
    , 'Men_80-84_140-159_200-250': 1.4
    , 'Men_80-84_140-159_250<': 1.4

    , 'Men_80-84_120-139_<150': 1.2
    , 'Men_80-84_120-139_150-200': 1.3
    , 'Men_80-84_120-139_200-250': 1.4
    , 'Men_80-84_120-139_250<': 1.5

    , 'Men_80-84_100-119_<150': 1.2
    , 'Men_80-84_100-119_150-200': 1.3
    , 'Men_80-84_100-119_200-250': 1.4
    , 'Men_80-84_100-119_250<': 1.5


    , 'Men_75-79_160-179_<150': 1.6
    , 'Men_75-79_160-179_150-200': 1.7
    , 'Men_75-79_160-179_200-250': 1.9
    , 'Men_75-79_160-179_250<': 1.9

    , 'Men_75-79_140-159_<150': 1.7
    , 'Men_75-79_140-159_150-200': 1.8
    , 'Men_75-79_140-159_200-250': 1.9
    , 'Men_75-79_140-159_250<': 1.9

    , 'Men_75-79_120-139_<150': 1.6
    , 'Men_75-79_120-139_150-200': 1.8
    , 'Men_75-79_120-139_200-250': 1.9
    , 'Men_75-79_120-139_250<': 2.0

    , 'Men_75-79_100-119_<150': 1.7
    , 'Men_75-79_100-119_150-200': 1.8
    , 'Men_75-79_100-119_200-250': 1.9
    , 'Men_75-79_100-119_250<': 1.9


    , 'Men_70-74_160-179_<150': 2.1
    , 'Men_70-74_160-179_150-200': 2.3
    , 'Men_70-74_160-179_200-250': 2.4
    , 'Men_70-74_160-179_250<': 2.5

    , 'Men_70-74_140-159_<150': 2.1
    , 'Men_70-74_140-159_150-200': 2.2
    , 'Men_70-74_140-159_200-250': 2.4
    , 'Men_70-74_140-159_250<': 2.4

    , 'Men_70-74_120-139_<150': 2.0
    , 'Men_70-74_120-139_150-200': 2.2
    , 'Men_70-74_120-139_200-250': 2.3
    , 'Men_70-74_120-139_250<': 2.4

    , 'Men_70-74_100-119_<150': 2.1
    , 'Men_70-74_100-119_150-200': 2.2
    , 'Men_70-74_100-119_200-250': 2.3
    , 'Men_70-74_100-119_250<': 2.3


    , 'Men_65-69_160-179_<150': 2.6
    , 'Men_65-69_160-179_150-200': 2.7
    , 'Men_65-69_160-179_200-250': 2.9
    , 'Men_65-69_160-179_250<': 2.9

    , 'Men_65-69_140-159_<150': 2.5
    , 'Men_65-69_140-159_150-200': 2.7
    , 'Men_65-69_140-159_200-250': 2.8
    , 'Men_65-69_140-159_250<': 2.8

    , 'Men_65-69_120-139_<150': 2.4
    , 'Men_65-69_120-139_150-200': 2.6
    , 'Men_65-69_120-139_200-250': 2.7
    , 'Men_65-69_120-139_250<': 2.7

    , 'Men_65-69_100-119_<150': 2.7
    , 'Men_65-69_100-119_150-200': 2.7
    , 'Men_65-69_100-119_200-250': 2.9
    , 'Men_65-69_100-119_250<': 2.9


    , 'Men_60-64_160-179_<150': 3.0
    , 'Men_60-64_160-179_150-200': 3.1
    , 'Men_60-64_160-179_200-250': 3.3
    , 'Men_60-64_160-179_250<': 3.4

    , 'Men_60-64_140-159_<150': 2.9
    , 'Men_60-64_140-159_150-200': 3.0
    , 'Men_60-64_140-159_200-250': 3.2
    , 'Men_60-64_140-159_250<': 3.3

    , 'Men_60-64_120-139_<150': 2.8
    , 'Men_60-64_120-139_150-200': 2.9
    , 'Men_60-64_120-139_200-250': 3.0
    , 'Men_60-64_120-139_250<': 3.1

    , 'Men_60-64_100-119_<150': 2.7
    , 'Men_60-64_100-119_150-200': 2.7
    , 'Men_60-64_100-119_200-250': 2.9
    , 'Men_60-64_100-119_250<': 2.9


    , 'Men_55-59_160-179_<150': 3.3
    , 'Men_55-59_160-179_150-200': 3.5
    , 'Men_55-59_160-179_200-250': 3.7
    , 'Men_55-59_160-179_250<': 3.8

    , 'Men_55-59_140-159_<150': 3.1
    , 'Men_55-59_140-159_150-200': 3.2
    , 'Men_55-59_140-159_200-250': 3.5
    , 'Men_55-59_140-159_250<': 3.6

    , 'Men_55-59_120-139_<150': 2.9
    , 'Men_55-59_120-139_150-200': 3.1
    , 'Men_55-59_120-139_200-250': 3.3
    , 'Men_55-59_120-139_250<': 3.4

    , 'Men_55-59_100-119_<150': 2.8
    , 'Men_55-59_100-119_150-200': 3.0
    , 'Men_55-59_100-119_200-250': 3.1
    , 'Men_55-59_100-119_250<': 3.2


    , 'Men_50-54_160-179_<150': 3.5
    , 'Men_50-54_160-179_150-200': 3.7
    , 'Men_50-54_160-179_200-250': 3.9
    , 'Men_50-54_160-179_250<': 4.2

    , 'Men_50-54_140-159_<150': 3.3
    , 'Men_50-54_140-159_150-200': 3.5
    , 'Men_50-54_140-159_200-250': 3.7
    , 'Men_50-54_140-159_250<': 3.9

    , 'Men_50-54_120-139_<150': 3.1
    , 'Men_50-54_120-139_150-200': 3.3
    , 'Men_50-54_120-139_200-250': 3.4
    , 'Men_50-54_120-139_250<': 3.6

    , 'Men_50-54_100-119_<150': 2.9
    , 'Men_50-54_100-119_150-200': 3.1
    , 'Men_50-54_100-119_200-250': 3.2
    , 'Men_50-54_100-119_250<': 3.3


    , 'Men_45-49_160-179_<150': 3.7
    , 'Men_45-49_160-179_150-200': 3.9
    , 'Men_45-49_160-179_200-250': 4.2
    , 'Men_45-49_160-179_250<': 4.4

    , 'Men_45-49_140-159_<150': 3.4
    , 'Men_45-49_140-159_150-200': 3.7
    , 'Men_45-49_140-159_200-250': 3.9
    , 'Men_45-49_140-159_250<': 4.1

    , 'Men_45-49_120-139_<150': 3.3
    , 'Men_45-49_120-139_150-200': 3.4
    , 'Men_45-49_120-139_200-250': 3.6
    , 'Men_45-49_120-139_250<': 3.7

    , 'Men_45-49_100-119_<150': 3.1
    , 'Men_45-49_100-119_150-200': 3.2
    , 'Men_45-49_100-119_200-250': 3.3
    , 'Men_45-49_100-119_250<': 3.5


    , 'Men_40-44_160-179_<150': 3.7
    , 'Men_40-44_160-179_150-200': 4.0
    , 'Men_40-44_160-179_200-250': 4.3
    , 'Men_40-44_160-179_250<': 4.5

    , 'Men_40-44_140-159_<150': 3.5
    , 'Men_40-44_140-159_150-200': 3.7
    , 'Men_40-44_140-159_200-250': 4.0
    , 'Men_40-44_140-159_250<': 4.2

    , 'Men_40-44_120-139_<150': 3.3
    , 'Men_40-44_120-139_150-200': 3.5
    , 'Men_40-44_120-139_200-250': 3.7
    , 'Men_40-44_120-139_250<': 3.9

    , 'Men_40-44_100-119_<150': 3.2
    , 'Men_40-44_100-119_150-200': 3.3
    , 'Men_40-44_100-119_200-250': 3.4
    , 'Men_40-44_100-119_250<': 3.6
};

// Systolic blood pressure calculations (subset - will be expanded)
const calcSystolic: Record<string, number> = {
    'Women_nonsmoking_90+_160-179_<150': 0.3
    , 'Women_nonsmoking_90+_160-179_150-200': 0.3
    , 'Women_nonsmoking_90+_160-179_200-250': 0.4
    , 'Women_nonsmoking_90+_160-179_250<': 0.4

    , 'Women_nonsmoking_90+_140-159_<150': 0.3
    , 'Women_nonsmoking_90+_140-159_150-200': 0.3
    , 'Women_nonsmoking_90+_140-159_200-250': 0.3
    , 'Women_nonsmoking_90+_140-159_250<': 0.3

    , 'Women_nonsmoking_90+_120-139_<150': 0.2
    , 'Women_nonsmoking_90+_120-139_150-200': 0.3
    , 'Women_nonsmoking_90+_120-139_200-250': 0.3
    , 'Women_nonsmoking_90+_120-139_250<': 0.3

    , 'Women_nonsmoking_90+_100-119_<150': -1
    , 'Women_nonsmoking_90+_100-119_150-200': -1
    , 'Women_nonsmoking_90+_100-119_200-250': -1
    , 'Women_nonsmoking_90+_100-119_250<': -1


    , 'Women_nonsmoking_85-89_160-179_<150': 0.7
    , 'Women_nonsmoking_85-89_160-179_150-200': 0.8
    , 'Women_nonsmoking_85-89_160-179_200-250': 0.8
    , 'Women_nonsmoking_85-89_160-179_250<': 0.8

    , 'Women_nonsmoking_85-89_140-159_<150': 0.6
    , 'Women_nonsmoking_85-89_140-159_150-200': 0.6
    , 'Women_nonsmoking_85-89_140-159_200-250': 0.7
    , 'Women_nonsmoking_85-89_140-159_250<': 0.8

    , 'Women_nonsmoking_85-89_120-139_<150': 0.4
    , 'Women_nonsmoking_85-89_120-139_150-200': 0.5
    , 'Women_nonsmoking_85-89_120-139_200-250': 0.6
    , 'Women_nonsmoking_85-89_120-139_250<': 0.6

    , 'Women_nonsmoking_85-89_100-119_<150': -1
    , 'Women_nonsmoking_85-89_100-119_150-200': -1
    , 'Women_nonsmoking_85-89_100-119_200-250': -1
    , 'Women_nonsmoking_85-89_100-119_250<': -1


    , 'Women_nonsmoking_80-84_160-179_<150': 0.9
    , 'Women_nonsmoking_80-84_160-179_150-200': 1.0
    , 'Women_nonsmoking_80-84_160-179_200-250': 1.1
    , 'Women_nonsmoking_80-84_160-179_250<': 1.2

    , 'Women_nonsmoking_80-84_140-159_<150': 0.8
    , 'Women_nonsmoking_80-84_140-159_150-200': 0.9
    , 'Women_nonsmoking_80-84_140-159_200-250': 1.0
    , 'Women_nonsmoking_80-84_140-159_250<': 1.0

    , 'Women_nonsmoking_80-84_120-139_<150': 0.6
    , 'Women_nonsmoking_80-84_120-139_150-200': 0.7
    , 'Women_nonsmoking_80-84_120-139_200-250': 0.8
    , 'Women_nonsmoking_80-84_120-139_250<': 0.9

    , 'Women_nonsmoking_80-84_100-119_<150': -1
    , 'Women_nonsmoking_80-84_100-119_150-200': -1
    , 'Women_nonsmoking_80-84_100-119_200-250': -1
    , 'Women_nonsmoking_80-84_100-119_250<': -1


    , 'Women_nonsmoking_75-79_160-179_<150': 1.1
    , 'Women_nonsmoking_75-79_160-179_150-200': 1.2
    , 'Women_nonsmoking_75-79_160-179_200-250': 1.3
    , 'Women_nonsmoking_75-79_160-179_250<': 1.3

    , 'Women_nonsmoking_75-79_140-159_<150': 0.9
    , 'Women_nonsmoking_75-79_140-159_150-200': 1.1
    , 'Women_nonsmoking_75-79_140-159_200-250': 1.2
    , 'Women_nonsmoking_75-79_140-159_250<': 1.2

    , 'Women_nonsmoking_75-79_120-139_<150': 0.7
    , 'Women_nonsmoking_75-79_120-139_150-200': 0.9
    , 'Women_nonsmoking_75-79_120-139_200-250': 1.0
    , 'Women_nonsmoking_75-79_120-139_250<': 1.1

    , 'Women_nonsmoking_75-79_100-119_<150': -1
    , 'Women_nonsmoking_75-79_100-119_150-200': -1
    , 'Women_nonsmoking_75-79_100-119_200-250': -1
    , 'Women_nonsmoking_75-79_100-119_250<': -1


    , 'Women_nonsmoking_70-74_160-179_<150': 1.2
    , 'Women_nonsmoking_70-74_160-179_150-200': 1.3
    , 'Women_nonsmoking_70-74_160-179_200-250': 1.4
    , 'Women_nonsmoking_70-74_160-179_250<': 1.5

    , 'Women_nonsmoking_70-74_140-159_<150': 1.0
    , 'Women_nonsmoking_70-74_140-159_150-200': 1.3
    , 'Women_nonsmoking_70-74_140-159_200-250': 1.4
    , 'Women_nonsmoking_70-74_140-159_250<': 1.5

    , 'Women_nonsmoking_70-74_120-139_<150': 0.8
    , 'Women_nonsmoking_70-74_120-139_150-200': 1.0
    , 'Women_nonsmoking_70-74_120-139_200-250': 1.1
    , 'Women_nonsmoking_70-74_120-139_250<': 1.2

    , 'Women_nonsmoking_70-74_100-119_<150': -1
    , 'Women_nonsmoking_70-74_100-119_150-200': -1
    , 'Women_nonsmoking_70-74_100-119_200-250': -1
    , 'Women_nonsmoking_70-74_100-119_250<': -1


    , 'Women_nonsmoking_65-69_160-179_<150': 1.2
    , 'Women_nonsmoking_65-69_160-179_150-200': 1.3
    , 'Women_nonsmoking_65-69_160-179_200-250': 1.5
    , 'Women_nonsmoking_65-69_160-179_250<': 1.5

    , 'Women_nonsmoking_65-69_140-159_<150': 1.0
    , 'Women_nonsmoking_65-69_140-159_150-200': 1.3
    , 'Women_nonsmoking_65-69_140-159_200-250': 1.4
    , 'Women_nonsmoking_65-69_140-159_250<': 1.5

    , 'Women_nonsmoking_65-69_120-139_<150': 0.9
    , 'Women_nonsmoking_65-69_120-139_150-200': 1.1
    , 'Women_nonsmoking_65-69_120-139_200-250': 1.2
    , 'Women_nonsmoking_65-69_120-139_250<': 1.3

    , 'Women_nonsmoking_65-69_100-119_<150': -1
    , 'Women_nonsmoking_65-69_100-119_150-200': -1
    , 'Women_nonsmoking_65-69_100-119_200-250': -1
    , 'Women_nonsmoking_65-69_100-119_250<': -1


    , 'Women_nonsmoking_60-64_160-179_<150': 1.3
    , 'Women_nonsmoking_60-64_160-179_150-200': 1.4
    , 'Women_nonsmoking_60-64_160-179_200-250': 1.5
    , 'Women_nonsmoking_60-64_160-179_250<': 1.6

    , 'Women_nonsmoking_60-64_140-159_<150': 1.2
    , 'Women_nonsmoking_60-64_140-159_150-200': 1.3
    , 'Women_nonsmoking_60-64_140-159_200-250': 1.4
    , 'Women_nonsmoking_60-64_140-159_250<': 1.5

    , 'Women_nonsmoking_60-64_120-139_<150': 1.0
    , 'Women_nonsmoking_60-64_120-139_150-200': 1.1
    , 'Women_nonsmoking_60-64_120-139_200-250': 1.3
    , 'Women_nonsmoking_60-64_120-139_250<': 1.4

    , 'Women_nonsmoking_60-64_100-119_<150': -1
    , 'Women_nonsmoking_60-64_100-119_150-200': -1
    , 'Women_nonsmoking_60-64_100-119_200-250': -1
    , 'Women_nonsmoking_60-64_100-119_250<': -1


    , 'Women_nonsmoking_55-59_160-179_<150': 1.3
    , 'Women_nonsmoking_55-59_160-179_150-200': 1.5
    , 'Women_nonsmoking_55-59_160-179_200-250': 1.6
    , 'Women_nonsmoking_55-59_160-179_250<': 1.7

    , 'Women_nonsmoking_55-59_140-159_<150': 1.1
    , 'Women_nonsmoking_55-59_140-159_150-200': 1.4
    , 'Women_nonsmoking_55-59_140-159_200-250': 1.6
    , 'Women_nonsmoking_55-59_140-159_250<': 1.6

    , 'Women_nonsmoking_55-59_120-139_<150': 1.0
    , 'Women_nonsmoking_55-59_120-139_150-200': 1.2
    , 'Women_nonsmoking_55-59_120-139_200-250': 1.4
    , 'Women_nonsmoking_55-59_120-139_250<': 1.5

    , 'Women_nonsmoking_55-59_100-119_<150': -1
    , 'Women_nonsmoking_55-59_100-119_150-200': -1
    , 'Women_nonsmoking_55-59_100-119_200-250': -1
    , 'Women_nonsmoking_55-59_100-119_250<': -1


    , 'Women_nonsmoking_50-54_160-179_<150': 1.3
    , 'Women_nonsmoking_50-54_160-179_150-200': 1.5
    , 'Women_nonsmoking_50-54_160-179_200-250': 1.7
    , 'Women_nonsmoking_50-54_160-179_250<': 1.7

    , 'Women_nonsmoking_50-54_140-159_<150': 1.3
    , 'Women_nonsmoking_50-54_140-159_150-200': 1.4
    , 'Women_nonsmoking_50-54_140-159_200-250': 1.6
    , 'Women_nonsmoking_50-54_140-159_250<': 1.7

    , 'Women_nonsmoking_50-54_120-139_<150': 1.1
    , 'Women_nonsmoking_50-54_120-139_150-200': 1.2
    , 'Women_nonsmoking_50-54_120-139_200-250': 1.4
    , 'Women_nonsmoking_50-54_120-139_250<': 1.5

    , 'Women_nonsmoking_50-54_100-119_<150': -1
    , 'Women_nonsmoking_50-54_100-119_150-200': -1
    , 'Women_nonsmoking_50-54_100-119_200-250': -1
    , 'Women_nonsmoking_50-54_100-119_250<': -1


    , 'Women_nonsmoking_45-49_160-179_<150': 1.3
    , 'Women_nonsmoking_45-49_160-179_150-200': 1.6
    , 'Women_nonsmoking_45-49_160-179_200-250': 1.7
    , 'Women_nonsmoking_45-49_160-179_250<': 1.8

    , 'Women_nonsmoking_45-49_140-159_<150': 1.3
    , 'Women_nonsmoking_45-49_140-159_150-200': 1.4
    , 'Women_nonsmoking_45-49_140-159_200-250': 1.6
    , 'Women_nonsmoking_45-49_140-159_250<': 1.6

    , 'Women_nonsmoking_45-49_120-139_<150': 1.1
    , 'Women_nonsmoking_45-49_120-139_150-200': 1.2
    , 'Women_nonsmoking_45-49_120-139_200-250': 1.4
    , 'Women_nonsmoking_45-49_120-139_250<': 1.5

    , 'Women_nonsmoking_45-49_100-119_<150': -1
    , 'Women_nonsmoking_45-49_100-119_150-200': -1
    , 'Women_nonsmoking_45-49_100-119_200-250': -1
    , 'Women_nonsmoking_45-49_100-119_250<': -1


    , 'Women_nonsmoking_40-44_160-179_<150': 1.4
    , 'Women_nonsmoking_40-44_160-179_150-200': 1.6
    , 'Women_nonsmoking_40-44_160-179_200-250': 1.7
    , 'Women_nonsmoking_40-44_160-179_250<': 1.8

    , 'Women_nonsmoking_40-44_140-159_<150': 1.3
    , 'Women_nonsmoking_40-44_140-159_150-200': 1.4
    , 'Women_nonsmoking_40-44_140-159_200-250': 1.6
    , 'Women_nonsmoking_40-44_140-159_250<': 1.7

    , 'Women_nonsmoking_40-44_120-139_<150': 1.1
    , 'Women_nonsmoking_40-44_120-139_150-200': 1.3
    , 'Women_nonsmoking_40-44_120-139_200-250': 1.4
    , 'Women_nonsmoking_40-44_120-139_250<': 1.5

    , 'Women_nonsmoking_40-44_100-119_<150': -1
    , 'Women_nonsmoking_40-44_100-119_150-200': -1
    , 'Women_nonsmoking_40-44_100-119_200-250': -1
    , 'Women_nonsmoking_40-44_100-119_250<': -1


    , 'Women_smoking_90+_160-179_<150': 0.1
    , 'Women_smoking_90+_160-179_150-200': 0.1
    , 'Women_smoking_90+_160-179_200-250': 0.2
    , 'Women_smoking_90+_160-179_250<': 0.2

    , 'Women_smoking_90+_140-159_<150': 0.1
    , 'Women_smoking_90+_140-159_150-200': 0.1
    , 'Women_smoking_90+_140-159_200-250': 0.1
    , 'Women_smoking_90+_140-159_250<': 0.1

    , 'Women_smoking_90+_120-139_<150': 0.0
    , 'Women_smoking_90+_120-139_150-200': 0.1
    , 'Women_smoking_90+_120-139_200-250': 0.1
    , 'Women_smoking_90+_120-139_250<': 0.1

    , 'Women_smoking_90+_100-119_<150': -1
    , 'Women_smoking_90+_100-119_150-200': -1
    , 'Women_smoking_90+_100-119_200-250': -1
    , 'Women_smoking_90+_100-119_250<': -1


    , 'Women_smoking_85-89_160-179_<150': 0.2
    , 'Women_smoking_85-89_160-179_150-200': 0.2
    , 'Women_smoking_85-89_160-179_200-250': 0.3
    , 'Women_smoking_85-89_160-179_250<': 0.3

    , 'Women_smoking_85-89_140-159_<150': 0.1
    , 'Women_smoking_85-89_140-159_150-200': 0.2
    , 'Women_smoking_85-89_140-159_200-250': 0.2
    , 'Women_smoking_85-89_140-159_250<': 0.3

    , 'Women_smoking_85-89_120-139_<150': 0.1
    , 'Women_smoking_85-89_120-139_150-200': 0.2
    , 'Women_smoking_85-89_120-139_200-250': 0.2
    , 'Women_smoking_85-89_120-139_250<': 0.2

    , 'Women_smoking_85-89_100-119_<150': -1
    , 'Women_smoking_85-89_100-119_150-200': -1
    , 'Women_smoking_85-89_100-119_200-250': -1
    , 'Women_smoking_85-89_100-119_250<': -1


    , 'Women_smoking_80-84_160-179_<150': 0.2
    , 'Women_smoking_80-84_160-179_150-200': 0.3
    , 'Women_smoking_80-84_160-179_200-250': 0.4
    , 'Women_smoking_80-84_160-179_250<': 0.4

    , 'Women_smoking_80-84_140-159_<150': 0.2
    , 'Women_smoking_80-84_140-159_150-200': 0.3
    , 'Women_smoking_80-84_140-159_200-250': 0.3
    , 'Women_smoking_80-84_140-159_250<': 0.4

    , 'Women_smoking_80-84_120-139_<150': 0.2
    , 'Women_smoking_80-84_120-139_150-200': 0.1
    , 'Women_smoking_80-84_120-139_200-250': 0.3
    , 'Women_smoking_80-84_120-139_250<': 0.2

    , 'Women_smoking_80-84_100-119_<150': -1
    , 'Women_smoking_80-84_100-119_150-200': -1
    , 'Women_smoking_80-84_100-119_200-250': -1
    , 'Women_smoking_80-84_100-119_250<': -1


    , 'Women_smoking_75-79_160-179_<150': 0.3
    , 'Women_smoking_75-79_160-179_150-200': 0.5
    , 'Women_smoking_75-79_160-179_200-250': 0.5
    , 'Women_smoking_75-79_160-179_250<': 0.5

    , 'Women_smoking_75-79_140-159_<150': 0.2
    , 'Women_smoking_75-79_140-159_150-200': 0.3
    , 'Women_smoking_75-79_140-159_200-250': 0.4
    , 'Women_smoking_75-79_140-159_250<': 0.5

    , 'Women_smoking_75-79_120-139_<150': 0.2
    , 'Women_smoking_75-79_120-139_150-200': 0.2
    , 'Women_smoking_75-79_120-139_200-250': 0.3
    , 'Women_smoking_75-79_120-139_250<': 0.4

    , 'Women_smoking_75-79_100-119_<150': -1
    , 'Women_smoking_75-79_100-119_150-200': -1
    , 'Women_smoking_75-79_100-119_200-250': -1
    , 'Women_smoking_75-79_100-119_250<': -1


    , 'Women_smoking_70-74_160-179_<150': 0.4
    , 'Women_smoking_70-74_160-179_150-200': 0.5
    , 'Women_smoking_70-74_160-179_200-250': 0.7
    , 'Women_smoking_70-74_160-179_250<': 0.7

    , 'Women_smoking_70-74_140-159_<150': 0.4
    , 'Women_smoking_70-74_140-159_150-200': 0.4
    , 'Women_smoking_70-74_140-159_200-250': 0.5
    , 'Women_smoking_70-74_140-159_250<': 0.6

    , 'Women_smoking_70-74_120-139_<150': 0.2
    , 'Women_smoking_70-74_120-139_150-200': 0.3
    , 'Women_smoking_70-74_120-139_200-250': 0.4
    , 'Women_smoking_70-74_120-139_250<': 0.5

    , 'Women_smoking_70-74_100-119_<150': -1
    , 'Women_smoking_70-74_100-119_150-200': -1
    , 'Women_smoking_70-74_100-119_200-250': -1
    , 'Women_smoking_70-74_100-119_250<': -1


    , 'Women_smoking_65-69_160-179_<150': 0.5
    , 'Women_smoking_65-69_160-179_150-200': 0.7
    , 'Women_smoking_65-69_160-179_200-250': 0.8
    , 'Women_smoking_65-69_160-179_250<': 0.9

    , 'Women_smoking_65-69_140-159_<150': 0.4
    , 'Women_smoking_65-69_140-159_150-200': 0.5
    , 'Women_smoking_65-69_140-159_200-250': 0.6
    , 'Women_smoking_65-69_140-159_250<': 0.7

    , 'Women_smoking_65-69_120-139_<150': 0.3
    , 'Women_smoking_65-69_120-139_150-200': 0.4
    , 'Women_smoking_65-69_120-139_200-250': 0.5
    , 'Women_smoking_65-69_120-139_250<': 0.5

    , 'Women_smoking_65-69_100-119_<150': -1
    , 'Women_smoking_65-69_100-119_150-200': -1
    , 'Women_smoking_65-69_100-119_200-250': -1
    , 'Women_smoking_65-69_100-119_250<': -1


    , 'Women_smoking_60-64_160-179_<150': 0.6
    , 'Women_smoking_60-64_160-179_150-200': 0.7
    , 'Women_smoking_60-64_160-179_200-250': 0.9
    , 'Women_smoking_60-64_160-179_250<': 1.0

    , 'Women_smoking_60-64_140-159_<150': 0.5
    , 'Women_smoking_60-64_140-159_150-200': 0.6
    , 'Women_smoking_60-64_140-159_200-250': 0.7
    , 'Women_smoking_60-64_140-159_250<': 0.8

    , 'Women_smoking_60-64_120-139_<150': 0.4
    , 'Women_smoking_60-64_120-139_150-200': 0.4
    , 'Women_smoking_60-64_120-139_200-250': 0.6
    , 'Women_smoking_60-64_120-139_250<': 0.6

    , 'Women_smoking_60-64_100-119_<150': -1
    , 'Women_smoking_60-64_100-119_150-200': -1
    , 'Women_smoking_60-64_100-119_200-250': -1
    , 'Women_smoking_60-64_100-119_250<': -1


    , 'Women_smoking_55-59_160-179_<150': 0.7
    , 'Women_smoking_55-59_160-179_150-200': 0.9
    , 'Women_smoking_55-59_160-179_200-250': 1.0
    , 'Women_smoking_55-59_160-179_250<': 1.1

    , 'Women_smoking_55-59_140-159_<150': 0.6
    , 'Women_smoking_55-59_140-159_150-200': 0.7
    , 'Women_smoking_55-59_140-159_200-250': 0.8
    , 'Women_smoking_55-59_140-159_250<': 1.0

    , 'Women_smoking_55-59_120-139_<150': 0.4
    , 'Women_smoking_55-59_120-139_150-200': 0.5
    , 'Women_smoking_55-59_120-139_200-250': 0.7
    , 'Women_smoking_55-59_120-139_250<': 0.7

    , 'Women_smoking_55-59_100-119_<150': -1
    , 'Women_smoking_55-59_100-119_150-200': -1
    , 'Women_smoking_55-59_100-119_200-250': -1
    , 'Women_smoking_55-59_100-119_250<': -1


    , 'Women_smoking_50-54_160-179_<150': 0.8
    , 'Women_smoking_50-54_160-179_150-200': 1.0
    , 'Women_smoking_50-54_160-179_200-250': 1.1
    , 'Women_smoking_50-54_160-179_250<': 1.2

    , 'Women_smoking_50-54_140-159_<150': 0.6
    , 'Women_smoking_50-54_140-159_150-200': 0.8
    , 'Women_smoking_50-54_140-159_200-250': 1.0
    , 'Women_smoking_50-54_140-159_250<': 1.0

    , 'Women_smoking_50-54_120-139_<150': 0.5
    , 'Women_smoking_50-54_120-139_150-200': 0.6
    , 'Women_smoking_50-54_120-139_200-250': 0.7
    , 'Women_smoking_50-54_120-139_250<': 0.8

    , 'Women_smoking_50-54_100-119_<150': -1
    , 'Women_smoking_50-54_100-119_150-200': -1
    , 'Women_smoking_50-54_100-119_200-250': -1
    , 'Women_smoking_50-54_100-119_250<': -1


    , 'Women_smoking_45-49_160-179_<150': 0.8
    , 'Women_smoking_45-49_160-179_150-200': 1.0
    , 'Women_smoking_45-49_160-179_200-250': 1.2
    , 'Women_smoking_45-49_160-179_250<': 1.3

    , 'Women_smoking_45-49_140-159_<150': 0.7
    , 'Women_smoking_45-49_140-159_150-200': 0.8
    , 'Women_smoking_45-49_140-159_200-250': 1.0
    , 'Women_smoking_45-49_140-159_250<': 1.1

    , 'Women_smoking_45-49_120-139_<150': 0.5
    , 'Women_smoking_45-49_120-139_150-200': 0.7
    , 'Women_smoking_45-49_120-139_200-250': 0.8
    , 'Women_smoking_45-49_120-139_250<': 0.8

    , 'Women_smoking_45-49_100-119_<150': -1
    , 'Women_smoking_45-49_100-119_150-200': -1
    , 'Women_smoking_45-49_100-119_200-250': -1
    , 'Women_smoking_45-49_100-119_250<': -1


    , 'Women_smoking_40-44_160-179_<150': 0.8
    , 'Women_smoking_40-44_160-179_150-200': 1.0
    , 'Women_smoking_40-44_160-179_200-250': 1.2
    , 'Women_smoking_40-44_160-179_250<': 1.3

    , 'Women_smoking_40-44_140-159_<150': 0.7
    , 'Women_smoking_40-44_140-159_150-200': 0.8
    , 'Women_smoking_40-44_140-159_200-250': 1.0
    , 'Women_smoking_40-44_140-159_250<': 1.1

    , 'Women_smoking_40-44_120-139_<150': 0.6
    , 'Women_smoking_40-44_120-139_150-200': 0.7
    , 'Women_smoking_40-44_120-139_200-250': 0.8
    , 'Women_smoking_40-44_120-139_250<': 0.9

    , 'Women_smoking_40-44_100-119_<150': -1
    , 'Women_smoking_40-44_100-119_150-200': -1
    , 'Women_smoking_40-44_100-119_200-250': -1
    , 'Women_smoking_40-44_100-119_250<': -1

    , 'Men_nonsmoking_90+_160-179_<150': 0.2
    , 'Men_nonsmoking_90+_160-179_150-200': 0.2
    , 'Men_nonsmoking_90+_160-179_200-250': 0.3
    , 'Men_nonsmoking_90+_160-179_250<': 0.3

    , 'Men_nonsmoking_90+_140-159_<150': 0.2
    , 'Men_nonsmoking_90+_140-159_150-200': 0.2
    , 'Men_nonsmoking_90+_140-159_200-250': 0.2
    , 'Men_nonsmoking_90+_140-159_250<': 0.2

    , 'Men_nonsmoking_90+_120-139_<150': 0.1
    , 'Men_nonsmoking_90+_120-139_150-200': 0.1
    , 'Men_nonsmoking_90+_120-139_200-250': 0.2
    , 'Men_nonsmoking_90+_120-139_250<': 0.2

    , 'Men_nonsmoking_90+_100-119_<150': -1
    , 'Men_nonsmoking_90+_100-119_150-200': -1
    , 'Men_nonsmoking_90+_100-119_200-250': -1
    , 'Men_nonsmoking_90+_100-119_250<': -1


    , 'Men_nonsmoking_85-89_160-179_<150': 0.3
    , 'Men_nonsmoking_85-89_160-179_150-200': 0.4
    , 'Men_nonsmoking_85-89_160-179_200-250': 0.5
    , 'Men_nonsmoking_85-89_160-179_250<': 0.5

    , 'Men_nonsmoking_85-89_140-159_<150': 0.3
    , 'Men_nonsmoking_85-89_140-159_150-200': 0.3
    , 'Men_nonsmoking_85-89_140-159_200-250': 0.4
    , 'Men_nonsmoking_85-89_140-159_250<': 0.5

    , 'Men_nonsmoking_85-89_120-139_<150': 0.3
    , 'Men_nonsmoking_85-89_120-139_150-200': 0.3
    , 'Men_nonsmoking_85-89_120-139_200-250': 0.3
    , 'Men_nonsmoking_85-89_120-139_250<': 0.4

    , 'Men_nonsmoking_85-89_100-119_<150': -1
    , 'Men_nonsmoking_85-89_100-119_150-200': -1
    , 'Men_nonsmoking_85-89_100-119_200-250': -1
    , 'Men_nonsmoking_85-89_100-119_250<': -1


    , 'Men_nonsmoking_80-84_160-179_<150': 0.5
    , 'Men_nonsmoking_80-84_160-179_150-200': 0.5
    , 'Men_nonsmoking_80-84_160-179_200-250': 0.6
    , 'Men_nonsmoking_80-84_160-179_250<': 0.7

    , 'Men_nonsmoking_80-84_140-159_<150': 0.4
    , 'Men_nonsmoking_80-84_140-159_150-200': 0.5
    , 'Men_nonsmoking_80-84_140-159_200-250': 0.6
    , 'Men_nonsmoking_80-84_140-159_250<': 0.6

    , 'Men_nonsmoking_80-84_120-139_<150': 0.3
    , 'Men_nonsmoking_80-84_120-139_150-200': 0.4
    , 'Men_nonsmoking_80-84_120-139_200-250': 0.4
    , 'Men_nonsmoking_80-84_120-139_250<': 0.5

    , 'Men_nonsmoking_80-84_100-119_<150': -1
    , 'Men_nonsmoking_80-84_100-119_150-200': -1
    , 'Men_nonsmoking_80-84_100-119_200-250': -1
    , 'Men_nonsmoking_80-84_100-119_250<': -1


    , 'Men_nonsmoking_75-79_160-179_<150': 0.6
    , 'Men_nonsmoking_75-79_160-179_150-200': 0.7
    , 'Men_nonsmoking_75-79_160-179_200-250': 0.8
    , 'Men_nonsmoking_75-79_160-179_250<': 0.9

    , 'Men_nonsmoking_75-79_140-159_<150': 0.5
    , 'Men_nonsmoking_75-79_140-159_150-200': 0.6
    , 'Men_nonsmoking_75-79_140-159_200-250': 0.7
    , 'Men_nonsmoking_75-79_140-159_250<': 0.8

    , 'Men_nonsmoking_75-79_120-139_<150': 0.4
    , 'Men_nonsmoking_75-79_120-139_150-200': 0.5
    , 'Men_nonsmoking_75-79_120-139_200-250': 0.6
    , 'Men_nonsmoking_75-79_120-139_250<': 0.6

    , 'Men_nonsmoking_75-79_100-119_<150': -1
    , 'Men_nonsmoking_75-79_100-119_150-200': -1
    , 'Men_nonsmoking_75-79_100-119_200-250': -1
    , 'Men_nonsmoking_75-79_100-119_250<': -1


    , 'Men_nonsmoking_70-74_160-179_<150': 0.7
    , 'Men_nonsmoking_70-74_160-179_150-200': 0.8
    , 'Men_nonsmoking_70-74_160-179_200-250': 1.0
    , 'Men_nonsmoking_70-74_160-179_250<': 1.0

    , 'Men_nonsmoking_70-74_140-159_<150': 0.6
    , 'Men_nonsmoking_70-74_140-159_150-200': 0.7
    , 'Men_nonsmoking_70-74_140-159_200-250': 0.9
    , 'Men_nonsmoking_70-74_140-159_250<': 0.9

    , 'Men_nonsmoking_70-74_120-139_<150': 0.4
    , 'Men_nonsmoking_70-74_120-139_150-200': 0.6
    , 'Men_nonsmoking_70-74_120-139_200-250': 0.7
    , 'Men_nonsmoking_70-74_120-139_250<': 0.8

    , 'Men_nonsmoking_70-74_100-119_<150': -1
    , 'Men_nonsmoking_70-74_100-119_150-200': -1
    , 'Men_nonsmoking_70-74_100-119_200-250': -1
    , 'Men_nonsmoking_70-74_100-119_250<': -1


    , 'Men_nonsmoking_65-69_160-179_<150': 0.8
    , 'Men_nonsmoking_65-69_160-179_150-200': 1.0
    , 'Men_nonsmoking_65-69_160-179_200-250': 1.1
    , 'Men_nonsmoking_65-69_160-179_250<': 1.1

    , 'Men_nonsmoking_65-69_140-159_<150': 0.7
    , 'Men_nonsmoking_65-69_140-159_150-200': 0.9
    , 'Men_nonsmoking_65-69_140-159_200-250': 0.9
    , 'Men_nonsmoking_65-69_140-159_250<': 1.0

    , 'Men_nonsmoking_65-69_120-139_<150': 0.5
    , 'Men_nonsmoking_65-69_120-139_150-200': 0.7
    , 'Men_nonsmoking_65-69_120-139_200-250': 0.8
    , 'Men_nonsmoking_65-69_120-139_250<': 0.9

    , 'Men_nonsmoking_65-69_100-119_<150': -1
    , 'Men_nonsmoking_65-69_100-119_150-200': -1
    , 'Men_nonsmoking_65-69_100-119_200-250': -1
    , 'Men_nonsmoking_65-69_100-119_250<': -1


    , 'Men_nonsmoking_60-64_160-179_<150': 1.0
    , 'Men_nonsmoking_60-64_160-179_150-200': 1.1
    , 'Men_nonsmoking_60-64_160-179_200-250': 1.2
    , 'Men_nonsmoking_60-64_160-179_250<': 1.3

    , 'Men_nonsmoking_60-64_140-159_<150': 0.8
    , 'Men_nonsmoking_60-64_140-159_150-200': 0.9
    , 'Men_nonsmoking_60-64_140-159_200-250': 1.1
    , 'Men_nonsmoking_60-64_140-159_250<': 1.1

    , 'Men_nonsmoking_60-64_120-139_<150': 0.7
    , 'Men_nonsmoking_60-64_120-139_150-200': 0.7
    , 'Men_nonsmoking_60-64_120-139_200-250': 0.9
    , 'Men_nonsmoking_60-64_120-139_250<': 1.0

    , 'Men_nonsmoking_60-64_100-119_<150': -1
    , 'Men_nonsmoking_60-64_100-119_150-200': -1
    , 'Men_nonsmoking_60-64_100-119_200-250': -1
    , 'Men_nonsmoking_60-64_100-119_250<': -1


    , 'Men_nonsmoking_55-59_160-179_<150': 1.0
    , 'Men_nonsmoking_55-59_160-179_150-200': 1.2
    , 'Men_nonsmoking_55-59_160-179_200-250': 1.3
    , 'Men_nonsmoking_55-59_160-179_250<': 1.4

    , 'Men_nonsmoking_55-59_140-159_<150': 0.8
    , 'Men_nonsmoking_55-59_140-159_150-200': 1.0
    , 'Men_nonsmoking_55-59_140-159_200-250': 1.2
    , 'Men_nonsmoking_55-59_140-159_250<': 1.2

    , 'Men_nonsmoking_55-59_120-139_<150': 0.7
    , 'Men_nonsmoking_55-59_120-139_150-200': 0.8
    , 'Men_nonsmoking_55-59_120-139_200-250': 1.0
    , 'Men_nonsmoking_55-59_120-139_250<': 1.0

    , 'Men_nonsmoking_55-59_100-119_<150': -1
    , 'Men_nonsmoking_55-59_100-119_150-200': -1
    , 'Men_nonsmoking_55-59_100-119_200-250': -1
    , 'Men_nonsmoking_55-59_100-119_250<': -1


    , 'Men_nonsmoking_50-54_160-179_<150': 1.0
    , 'Men_nonsmoking_50-54_160-179_150-200': 1.3
    , 'Men_nonsmoking_50-54_160-179_200-250': 1.4
    , 'Men_nonsmoking_50-54_160-179_250<': 1.5

    , 'Men_nonsmoking_50-54_140-159_<150': 0.9
    , 'Men_nonsmoking_50-54_140-159_150-200': 1.1
    , 'Men_nonsmoking_50-54_140-159_200-250': 1.2
    , 'Men_nonsmoking_50-54_140-159_250<': 1.3

    , 'Men_nonsmoking_50-54_120-139_<150': 0.7
    , 'Men_nonsmoking_50-54_120-139_150-200': 0.9
    , 'Men_nonsmoking_50-54_120-139_200-250': 1.0
    , 'Men_nonsmoking_50-54_120-139_250<': 1.1

    , 'Men_nonsmoking_50-54_100-119_<150': -1
    , 'Men_nonsmoking_50-54_100-119_150-200': -1
    , 'Men_nonsmoking_50-54_100-119_200-250': -1
    , 'Men_nonsmoking_50-54_100-119_250<': -1


    , 'Men_nonsmoking_45-49_160-179_<150': 1.1
    , 'Men_nonsmoking_45-49_160-179_150-200': 1.3
    , 'Men_nonsmoking_45-49_160-179_200-250': 1.5
    , 'Men_nonsmoking_45-49_160-179_250<': 1.5

    , 'Men_nonsmoking_45-49_140-159_<150': 0.9
    , 'Men_nonsmoking_45-49_140-159_150-200': 1.1
    , 'Men_nonsmoking_45-49_140-159_200-250': 1.3
    , 'Men_nonsmoking_45-49_140-159_250<': 1.3

    , 'Men_nonsmoking_45-49_120-139_<150': 0.8
    , 'Men_nonsmoking_45-49_120-139_150-200': 0.9
    , 'Men_nonsmoking_45-49_120-139_200-250': 1.0
    , 'Men_nonsmoking_45-49_120-139_250<': 1.2

    , 'Men_nonsmoking_45-49_100-119_<150': -1
    , 'Men_nonsmoking_45-49_100-119_150-200': -1
    , 'Men_nonsmoking_45-49_100-119_200-250': -1
    , 'Men_nonsmoking_45-49_100-119_250<': -1


    , 'Men_nonsmoking_40-44_160-179_<150': 1.1
    , 'Men_nonsmoking_40-44_160-179_150-200': 1.3
    , 'Men_nonsmoking_40-44_160-179_200-250': 1.4
    , 'Men_nonsmoking_40-44_160-179_250<': 1.6

    , 'Men_nonsmoking_40-44_140-159_<150': 0.9
    , 'Men_nonsmoking_40-44_140-159_150-200': 1.1
    , 'Men_nonsmoking_40-44_140-159_200-250': 1.3
    , 'Men_nonsmoking_40-44_140-159_250<': 1.4

    , 'Men_nonsmoking_40-44_120-139_<150': 0.7
    , 'Men_nonsmoking_40-44_120-139_150-200': 0.9
    , 'Men_nonsmoking_40-44_120-139_200-250': 1.0
    , 'Men_nonsmoking_40-44_120-139_250<': 1.2

    , 'Men_nonsmoking_40-44_100-119_<150': -1
    , 'Men_nonsmoking_40-44_100-119_150-200': -1
    , 'Men_nonsmoking_40-44_100-119_200-250': -1
    , 'Men_nonsmoking_40-44_100-119_250<': -1

    , 'Men_smoking_90+_160-179_<150': 0.1
    , 'Men_smoking_90+_160-179_150-200': 0.0
    , 'Men_smoking_90+_160-179_200-250': 0.0
    , 'Men_smoking_90+_160-179_250<': 0.1

    , 'Men_smoking_90+_140-159_<150': 0.0
    , 'Men_smoking_90+_140-159_150-200': 0.0
    , 'Men_smoking_90+_140-159_200-250': 0.0
    , 'Men_smoking_90+_140-159_250<': 0.0

    , 'Men_smoking_90+_120-139_<150': 0.0
    , 'Men_smoking_90+_120-139_150-200': 0.0
    , 'Men_smoking_90+_120-139_200-250': 0.0
    , 'Men_smoking_90+_120-139_250<': 0.1

    , 'Men_smoking_90+_100-119_<150': -1
    , 'Men_smoking_90+_100-119_150-200': -1
    , 'Men_smoking_90+_100-119_200-250': -1
    , 'Men_smoking_90+_100-119_250<': -1


    , 'Men_smoking_85-89_160-179_<150': 0.1
    , 'Men_smoking_85-89_160-179_150-200': 0.1
    , 'Men_smoking_85-89_160-179_200-250': 0.1
    , 'Men_smoking_85-89_160-179_250<': 0.2

    , 'Men_smoking_85-89_140-159_<150': 0.1
    , 'Men_smoking_85-89_140-159_150-200': 0.1
    , 'Men_smoking_85-89_140-159_200-250': 0.1
    , 'Men_smoking_85-89_140-159_250<': 0.1

    , 'Men_smoking_85-89_120-139_<150': 0.0
    , 'Men_smoking_85-89_120-139_150-200': 0.0
    , 'Men_smoking_85-89_120-139_200-250': 0.01
    , 'Men_smoking_85-89_120-139_250<': 0.1

    , 'Men_smoking_85-89_100-119_<150': -1
    , 'Men_smoking_85-89_100-119_150-200': -1
    , 'Men_smoking_85-89_100-119_200-250': -1
    , 'Men_smoking_85-89_100-119_250<': -1


    , 'Men_smoking_80-84_160-179_<150': 0.1
    , 'Men_smoking_80-84_160-179_150-200': 0.2
    , 'Men_smoking_80-84_160-179_200-250': 0.2
    , 'Men_smoking_80-84_160-179_250<': 0.2

    , 'Men_smoking_80-84_140-159_<150': 0.1
    , 'Men_smoking_80-84_140-159_150-200': 0.1
    , 'Men_smoking_80-84_140-159_200-250': 0.2
    , 'Men_smoking_80-84_140-159_250<': 0.1

    , 'Men_smoking_80-84_120-139_<150': 0.0
    , 'Men_smoking_80-84_120-139_150-200': 0.1
    , 'Men_smoking_80-84_120-139_200-250': 0.1
    , 'Men_smoking_80-84_120-139_250<': 0.1

    , 'Men_smoking_80-84_100-119_<150': -1
    , 'Men_smoking_80-84_100-119_150-200': -1
    , 'Men_smoking_80-84_100-119_200-250': -1
    , 'Men_smoking_80-84_100-119_250<': -1


    , 'Men_smoking_75-79_160-179_<150': 0.2
    , 'Men_smoking_75-79_160-179_150-200': 0.2
    , 'Men_smoking_75-79_160-179_200-250': 0.3
    , 'Men_smoking_75-79_160-179_250<': 0.3

    , 'Men_smoking_75-79_140-159_<150': 0.2
    , 'Men_smoking_75-79_140-159_150-200': 0.2
    , 'Men_smoking_75-79_140-159_200-250': 0.3
    , 'Men_smoking_75-79_140-159_250<': 0.3

    , 'Men_smoking_75-79_120-139_<150': 0.1
    , 'Men_smoking_75-79_120-139_150-200': 0.2
    , 'Men_smoking_75-79_120-139_200-250': 0.2
    , 'Men_smoking_75-79_120-139_250<': 0.2

    , 'Men_smoking_75-79_100-119_<150': -1
    , 'Men_smoking_75-79_100-119_150-200': -1
    , 'Men_smoking_75-79_100-119_200-250': -1
    , 'Men_smoking_75-79_100-119_250<': -1


    , 'Men_smoking_70-74_160-179_<150': 0.3
    , 'Men_smoking_70-74_160-179_150-200': 0.4
    , 'Men_smoking_70-74_160-179_200-250': 0.5
    , 'Men_smoking_70-74_160-179_250<': 0.5

    , 'Men_smoking_70-74_140-159_<150': 0.2
    , 'Men_smoking_70-74_140-159_150-200': 0.3
    , 'Men_smoking_70-74_140-159_200-250': 0.4
    , 'Men_smoking_70-74_140-159_250<': 0.4

    , 'Men_smoking_70-74_120-139_<150': 0.1
    , 'Men_smoking_70-74_120-139_150-200': 0.2
    , 'Men_smoking_70-74_120-139_200-250': 0.3
    , 'Men_smoking_70-74_120-139_250<': 0.3

    , 'Men_smoking_70-74_100-119_<150': -1
    , 'Men_smoking_70-74_100-119_150-200': -1
    , 'Men_smoking_70-74_100-119_200-250': -1
    , 'Men_smoking_70-74_100-119_250<': -1


    , 'Men_smoking_65-69_160-179_<150': 0.5
    , 'Men_smoking_65-69_160-179_150-200': 0.5
    , 'Men_smoking_65-69_160-179_200-250': 0.7
    , 'Men_smoking_65-69_160-179_250<': 0.6

    , 'Men_smoking_65-69_140-159_<150': 0.3
    , 'Men_smoking_65-69_140-159_150-200': 0.5
    , 'Men_smoking_65-69_140-159_200-250': 0.5
    , 'Men_smoking_65-69_140-159_250<': 0.5

    , 'Men_smoking_65-69_120-139_<150': 0.2
    , 'Men_smoking_65-69_120-139_150-200': 0.4
    , 'Men_smoking_65-69_120-139_200-250': 0.4
    , 'Men_smoking_65-69_120-139_250<': 0.4

    , 'Men_smoking_65-69_100-119_<150': -1
    , 'Men_smoking_65-69_100-119_150-200': -1
    , 'Men_smoking_65-69_100-119_200-250': -1
    , 'Men_smoking_65-69_100-119_250<': -1


    , 'Men_smoking_60-64_160-179_<150': 0.6
    , 'Men_smoking_60-64_160-179_150-200': 0.7
    , 'Men_smoking_60-64_160-179_200-250': 0.8
    , 'Men_smoking_60-64_160-179_250<': 0.8

    , 'Men_smoking_60-64_140-159_<150': 0.5
    , 'Men_smoking_60-64_140-159_150-200': 0.5
    , 'Men_smoking_60-64_140-159_200-250': 0.7
    , 'Men_smoking_60-64_140-159_250<': 0.7

    , 'Men_smoking_60-64_120-139_<150': 0.4
    , 'Men_smoking_60-64_120-139_150-200': 0.4
    , 'Men_smoking_60-64_120-139_200-250': 0.5
    , 'Men_smoking_60-64_120-139_250<': 0.5

    , 'Men_smoking_60-64_100-119_<150': -1
    , 'Men_smoking_60-64_100-119_150-200': -1
    , 'Men_smoking_60-64_100-119_200-250': -1
    , 'Men_smoking_60-64_100-119_250<': -1


    , 'Men_smoking_55-59_160-179_<150': 0.7
    , 'Men_smoking_55-59_160-179_150-200': 0.9
    , 'Men_smoking_55-59_160-179_200-250': 0.9
    , 'Men_smoking_55-59_160-179_250<': 1.0

    , 'Men_smoking_55-59_140-159_<150': 0.5
    , 'Men_smoking_55-59_140-159_150-200': 0.6
    , 'Men_smoking_55-59_140-159_200-250': 0.8
    , 'Men_smoking_55-59_140-159_250<': 0.9

    , 'Men_smoking_55-59_120-139_<150': 0.4
    , 'Men_smoking_55-59_120-139_150-200': 0.5
    , 'Men_smoking_55-59_120-139_200-250': 0.6
    , 'Men_smoking_55-59_120-139_250<': 0.7

    , 'Men_smoking_55-59_100-119_<150': -1
    , 'Men_smoking_55-59_100-119_150-200': -1
    , 'Men_smoking_55-59_100-119_200-250': -1
    , 'Men_smoking_55-59_100-119_250<': -1


    , 'Men_smoking_50-54_160-179_<150': 0.8
    , 'Men_smoking_50-54_160-179_150-200': 0.9
    , 'Men_smoking_50-54_160-179_200-250': 1.0
    , 'Men_smoking_50-54_160-179_250<': 1.2

    , 'Men_smoking_50-54_140-159_<150': 0.7
    , 'Men_smoking_50-54_140-159_150-200': 0.7
    , 'Men_smoking_50-54_140-159_200-250': 0.8
    , 'Men_smoking_50-54_140-159_250<': 1.0

    , 'Men_smoking_50-54_120-139_<150': 0.5
    , 'Men_smoking_50-54_120-139_150-200': 0.6
    , 'Men_smoking_50-54_120-139_200-250': 0.7
    , 'Men_smoking_50-54_120-139_250<': 0.7

    , 'Men_smoking_50-54_100-119_<150': -1
    , 'Men_smoking_50-54_100-119_150-200': -1
    , 'Men_smoking_50-54_100-119_200-250': -1
    , 'Men_smoking_50-54_100-119_250<': -1


    , 'Men_smoking_45-49_160-179_<150': 0.8
    , 'Men_smoking_45-49_160-179_150-200': 1.0
    , 'Men_smoking_45-49_160-179_200-250': 1.2
    , 'Men_smoking_45-49_160-179_250<': 1.3

    , 'Men_smoking_45-49_140-159_<150': 0.7
    , 'Men_smoking_45-49_140-159_150-200': 0.8
    , 'Men_smoking_45-49_140-159_200-250': 1.0
    , 'Men_smoking_45-49_140-159_250<': 1.1

    , 'Men_smoking_45-49_120-139_<150': 0.6
    , 'Men_smoking_45-49_120-139_150-200': 0.7
    , 'Men_smoking_45-49_120-139_200-250': 0.8
    , 'Men_smoking_45-49_120-139_250<': 0.8

    , 'Men_smoking_45-49_100-119_<150': -1
    , 'Men_smoking_45-49_100-119_150-200': -1
    , 'Men_smoking_45-49_100-119_200-250': -1
    , 'Men_smoking_45-49_100-119_250<': -1


    , 'Men_smoking_40-44_160-179_<150': 0.9
    , 'Men_smoking_40-44_160-179_150-200': 1.1
    , 'Men_smoking_40-44_160-179_200-250': 1.3
    , 'Men_smoking_40-44_160-179_250<': 1.4

    , 'Men_smoking_40-44_140-159_<150': 0.7
    , 'Men_smoking_40-44_140-159_150-200': 0.9
    , 'Men_smoking_40-44_140-159_200-250': 1.0
    , 'Men_smoking_40-44_140-159_250<': 1.2

    , 'Men_smoking_40-44_120-139_<150': 0.6
    , 'Men_smoking_40-44_120-139_150-200': 0.7
    , 'Men_smoking_40-44_120-139_200-250': 0.8
    , 'Men_smoking_40-44_120-139_250<': 0.9

    , 'Men_smoking_40-44_100-119_<150': -1
    , 'Men_smoking_40-44_100-119_150-200': -1
    , 'Men_smoking_40-44_100-119_200-250': -1
    , 'Men_smoking_40-44_100-119_250<': -1
};

// LDL-C calculations (subset - will be expanded)
const calcLdlc: Record<string, number> = {
    'Women_nonsmoking_90+_160-179_<150': 0.3
    , 'Women_nonsmoking_90+_160-179_150-200': 0.4
    , 'Women_nonsmoking_90+_160-179_200-250': 0.4
    , 'Women_nonsmoking_90+_160-179_250<': 0.4

    , 'Women_nonsmoking_90+_140-159_<150': 0.3
    , 'Women_nonsmoking_90+_140-159_150-200': 0.3
    , 'Women_nonsmoking_90+_140-159_200-250': 0.4
    , 'Women_nonsmoking_90+_140-159_250<': 0.4

    , 'Women_nonsmoking_90+_120-139_<150': 0.2
    , 'Women_nonsmoking_90+_120-139_150-200': 0.3
    , 'Women_nonsmoking_90+_120-139_200-250': 0.3
    , 'Women_nonsmoking_90+_120-139_250<': 0.3

    , 'Women_nonsmoking_90+_100-119_<150': 0.2
    , 'Women_nonsmoking_90+_100-119_150-200': 0.2
    , 'Women_nonsmoking_90+_100-119_200-250': 0.2
    , 'Women_nonsmoking_90+_100-119_250<': 0.2


    , 'Women_nonsmoking_85-89_160-179_<150': 0.8
    , 'Women_nonsmoking_85-89_160-179_150-200': 0.8
    , 'Women_nonsmoking_85-89_160-179_200-250': 0.9
    , 'Women_nonsmoking_85-89_160-179_250<': 0.9

    , 'Women_nonsmoking_85-89_140-159_<150': 0.6
    , 'Women_nonsmoking_85-89_140-159_150-200': 0.7
    , 'Women_nonsmoking_85-89_140-159_200-250': 0.8
    , 'Women_nonsmoking_85-89_140-159_250<': 0.8

    , 'Women_nonsmoking_85-89_120-139_<150': 0.5
    , 'Women_nonsmoking_85-89_120-139_150-200': 0.6
    , 'Women_nonsmoking_85-89_120-139_200-250': 0.7
    , 'Women_nonsmoking_85-89_120-139_250<': 0.7

    , 'Women_nonsmoking_85-89_100-119_<150': 0.4
    , 'Women_nonsmoking_85-89_100-119_150-200': 0.4
    , 'Women_nonsmoking_85-89_100-119_200-250': 0.5
    , 'Women_nonsmoking_85-89_100-119_250<': 0.6


    , 'Women_nonsmoking_80-84_160-179_<150': 1.0
    , 'Women_nonsmoking_80-84_160-179_150-200': 1.1
    , 'Women_nonsmoking_80-84_160-179_200-250': 1.2
    , 'Women_nonsmoking_80-84_160-179_250<': 1.3

    , 'Women_nonsmoking_80-84_140-159_<150': 0.9
    , 'Women_nonsmoking_80-84_140-159_150-200': 1.0
    , 'Women_nonsmoking_80-84_140-159_200-250': 1.1
    , 'Women_nonsmoking_80-84_140-159_250<': 1.1

    , 'Women_nonsmoking_80-84_120-139_<150': 0.7
    , 'Women_nonsmoking_80-84_120-139_150-200': 0.8
    , 'Women_nonsmoking_80-84_120-139_200-250': 0.9
    , 'Women_nonsmoking_80-84_120-139_250<': 1.0

    , 'Women_nonsmoking_80-84_100-119_<150': 0.5
    , 'Women_nonsmoking_80-84_100-119_150-200': 0.6
    , 'Women_nonsmoking_80-84_100-119_200-250': 0.7
    , 'Women_nonsmoking_80-84_100-119_250<': 0.8


    , 'Women_nonsmoking_75-79_160-179_<150': 1.2
    , 'Women_nonsmoking_75-79_160-179_150-200': 1.3
    , 'Women_nonsmoking_75-79_160-179_200-250': 1.4
    , 'Women_nonsmoking_75-79_160-179_250<': 1.4

    , 'Women_nonsmoking_75-79_140-159_<150': 1.0
    , 'Women_nonsmoking_75-79_140-159_150-200': 1.2
    , 'Women_nonsmoking_75-79_140-159_200-250': 1.3
    , 'Women_nonsmoking_75-79_140-159_250<': 1.4

    , 'Women_nonsmoking_75-79_120-139_<150': 0.8
    , 'Women_nonsmoking_75-79_120-139_150-200': 1.0
    , 'Women_nonsmoking_75-79_120-139_200-250': 1.1
    , 'Women_nonsmoking_75-79_120-139_250<': 1.2

    , 'Women_nonsmoking_75-79_100-119_<150': 0.6
    , 'Women_nonsmoking_75-79_100-119_150-200': 0.8
    , 'Women_nonsmoking_75-79_100-119_200-250': 0.9
    , 'Women_nonsmoking_75-79_100-119_250<': 1.0


    , 'Women_nonsmoking_70-74_160-179_<150': 1.3
    , 'Women_nonsmoking_70-74_160-179_150-200': 14
    , 'Women_nonsmoking_70-74_160-179_200-250': 1.5
    , 'Women_nonsmoking_70-74_160-179_250<': 1.6

    , 'Women_nonsmoking_70-74_140-159_<150': 1.1
    , 'Women_nonsmoking_70-74_140-159_150-200': 1.3
    , 'Women_nonsmoking_70-74_140-159_200-250': 1.4
    , 'Women_nonsmoking_70-74_140-159_250<': 1.5

    , 'Women_nonsmoking_70-74_120-139_<150': 0.9
    , 'Women_nonsmoking_70-74_120-139_150-200': 1.1
    , 'Women_nonsmoking_70-74_120-139_200-250': 1.3
    , 'Women_nonsmoking_70-74_120-139_250<': 1.3

    , 'Women_nonsmoking_70-74_100-119_<150': 0.7
    , 'Women_nonsmoking_70-74_100-119_150-200': 0.9
    , 'Women_nonsmoking_70-74_100-119_200-250': 1.0
    , 'Women_nonsmoking_70-74_100-119_250<': 1.1


    , 'Women_nonsmoking_65-69_160-179_<150': 1.3
    , 'Women_nonsmoking_65-69_160-179_150-200': 1.5
    , 'Women_nonsmoking_65-69_160-179_200-250': 1.6
    , 'Women_nonsmoking_65-69_160-179_250<': 1.7

    , 'Women_nonsmoking_65-69_140-159_<150': 1.2
    , 'Women_nonsmoking_65-69_140-159_150-200': 1.4
    , 'Women_nonsmoking_65-69_140-159_200-250': 1.5
    , 'Women_nonsmoking_65-69_140-159_250<': 1.6

    , 'Women_nonsmoking_65-69_120-139_<150': 1.0
    , 'Women_nonsmoking_65-69_120-139_150-200': 1.2
    , 'Women_nonsmoking_65-69_120-139_200-250': 1.4
    , 'Women_nonsmoking_65-69_120-139_250<': 1.5

    , 'Women_nonsmoking_65-69_100-119_<150': 0.9
    , 'Women_nonsmoking_65-69_100-119_150-200': 1.0
    , 'Women_nonsmoking_65-69_100-119_200-250': 1.2
    , 'Women_nonsmoking_65-69_100-119_250<': 1.3


    , 'Women_nonsmoking_60-64_160-179_<150': 1.4
    , 'Women_nonsmoking_60-64_160-179_150-200': 1.6
    , 'Women_nonsmoking_60-64_160-179_200-250': 1.7
    , 'Women_nonsmoking_60-64_160-179_250<': 1.8

    , 'Women_nonsmoking_60-64_140-159_<150': 1.3
    , 'Women_nonsmoking_60-64_140-159_150-200': 1.4
    , 'Women_nonsmoking_60-64_140-159_200-250': 1.6
    , 'Women_nonsmoking_60-64_140-159_250<': 1.7

    , 'Women_nonsmoking_60-64_120-139_<150': 1.1
    , 'Women_nonsmoking_60-64_120-139_150-200': 1.3
    , 'Women_nonsmoking_60-64_120-139_200-250': 1.5
    , 'Women_nonsmoking_60-64_120-139_250<': 1.6

    , 'Women_nonsmoking_60-64_100-119_<150': 0.9
    , 'Women_nonsmoking_60-64_100-119_150-200': 1.0
    , 'Women_nonsmoking_60-64_100-119_200-250': 1.2
    , 'Women_nonsmoking_60-64_100-119_250<': 1.3


    , 'Women_nonsmoking_55-59_160-179_<150': 1.5
    , 'Women_nonsmoking_55-59_160-179_150-200': 1.7
    , 'Women_nonsmoking_55-59_160-179_200-250': 1.8
    , 'Women_nonsmoking_55-59_160-179_250<': 1.9

    , 'Women_nonsmoking_55-59_140-159_<150': 1.3
    , 'Women_nonsmoking_55-59_140-159_150-200': 1.6
    , 'Women_nonsmoking_55-59_140-159_200-250': 1.7
    , 'Women_nonsmoking_55-59_140-159_250<': 1.8

    , 'Women_nonsmoking_55-59_120-139_<150': 1.1
    , 'Women_nonsmoking_55-59_120-139_150-200': 1.3
    , 'Women_nonsmoking_55-59_120-139_200-250': 1.5
    , 'Women_nonsmoking_55-59_120-139_250<': 1.6

    , 'Women_nonsmoking_55-59_100-119_<150': 0.9
    , 'Women_nonsmoking_55-59_100-119_150-200': 1.1
    , 'Women_nonsmoking_55-59_100-119_200-250': 1.3
    , 'Women_nonsmoking_55-59_100-119_250<': 1.4


    , 'Women_nonsmoking_50-54_160-179_<150': 1.5
    , 'Women_nonsmoking_50-54_160-179_150-200': 1.7
    , 'Women_nonsmoking_50-54_160-179_200-250': 1.8
    , 'Women_nonsmoking_50-54_160-179_250<': 1.9

    , 'Women_nonsmoking_50-54_140-159_<150': 1.4
    , 'Women_nonsmoking_50-54_140-159_150-200': 1.5
    , 'Women_nonsmoking_50-54_140-159_200-250': 1.8
    , 'Women_nonsmoking_50-54_140-159_250<': 1.9

    , 'Women_nonsmoking_50-54_120-139_<150': 1.2
    , 'Women_nonsmoking_50-54_120-139_150-200': 1.4
    , 'Women_nonsmoking_50-54_120-139_200-250': 1.6
    , 'Women_nonsmoking_50-54_120-139_250<': 1.7

    , 'Women_nonsmoking_50-54_100-119_<150': 0.9
    , 'Women_nonsmoking_50-54_100-119_150-200': 1.1
    , 'Women_nonsmoking_50-54_100-119_200-250': 1.3
    , 'Women_nonsmoking_50-54_100-119_250<': 1.5


    , 'Women_nonsmoking_45-49_160-179_<150': 1.5
    , 'Women_nonsmoking_45-49_160-179_150-200': 1.7
    , 'Women_nonsmoking_45-49_160-179_200-250': 1.9
    , 'Women_nonsmoking_45-49_160-179_250<': 2.0

    , 'Women_nonsmoking_45-49_140-159_<150': 1.4
    , 'Women_nonsmoking_45-49_140-159_150-200': 1.5
    , 'Women_nonsmoking_45-49_140-159_200-250': 1.7
    , 'Women_nonsmoking_45-49_140-159_250<': 1.8

    , 'Women_nonsmoking_45-49_120-139_<150': 1.2
    , 'Women_nonsmoking_45-49_120-139_150-200': 1.4
    , 'Women_nonsmoking_45-49_120-139_200-250': 1.6
    , 'Women_nonsmoking_45-49_120-139_250<': 1.7

    , 'Women_nonsmoking_45-49_100-119_<150': 0.9
    , 'Women_nonsmoking_45-49_100-119_150-200': 1.2
    , 'Women_nonsmoking_45-49_100-119_200-250': 1.4
    , 'Women_nonsmoking_45-49_100-119_250<': 1.5


    , 'Women_nonsmoking_40-44_160-179_<150': 1.6
    , 'Women_nonsmoking_40-44_160-179_150-200': 1.7
    , 'Women_nonsmoking_40-44_160-179_200-250': 1.9
    , 'Women_nonsmoking_40-44_160-179_250<': 2.0

    , 'Women_nonsmoking_40-44_140-159_<150': 1.4
    , 'Women_nonsmoking_40-44_140-159_150-200': 1.5
    , 'Women_nonsmoking_40-44_140-159_200-250': 1.7
    , 'Women_nonsmoking_40-44_140-159_250<': 1.8

    , 'Women_nonsmoking_40-44_120-139_<150': 1.2
    , 'Women_nonsmoking_40-44_120-139_150-200': 1.4
    , 'Women_nonsmoking_40-44_120-139_200-250': 1.6
    , 'Women_nonsmoking_40-44_120-139_250<': 1.7

    , 'Women_nonsmoking_40-44_100-119_<150': 1.0
    , 'Women_nonsmoking_40-44_100-119_150-200': 1.2
    , 'Women_nonsmoking_40-44_100-119_200-250': 1.4
    , 'Women_nonsmoking_40-44_100-119_250<': 1.5


    , 'Women_smoking_90+_160-179_<150': 0.1
    , 'Women_smoking_90+_160-179_150-200': 0.1
    , 'Women_smoking_90+_160-179_200-250': 0.2
    , 'Women_smoking_90+_160-179_250<': 0.2

    , 'Women_smoking_90+_140-159_<150': 0.1
    , 'Women_smoking_90+_140-159_150-200': 0.1
    , 'Women_smoking_90+_140-159_200-250': 0.1
    , 'Women_smoking_90+_140-159_250<': 0.1

    , 'Women_smoking_90+_120-139_<150': 0.1
    , 'Women_smoking_90+_120-139_150-200': 0.1
    , 'Women_smoking_90+_120-139_200-250': 0.1
    , 'Women_smoking_90+_120-139_250<': 0.1

    , 'Women_smoking_90+_100-119_<150': 0.0
    , 'Women_smoking_90+_100-119_150-200': 0.0
    , 'Women_smoking_90+_100-119_200-250': 0.1
    , 'Women_smoking_90+_100-119_250<': 0.1


    , 'Women_smoking_85-89_160-179_<150': 0.2
    , 'Women_smoking_85-89_160-179_150-200': 0.2
    , 'Women_smoking_85-89_160-179_200-250': 0.3
    , 'Women_smoking_85-89_160-179_250<': 0.4

    , 'Women_smoking_85-89_140-159_<150': 0.1
    , 'Women_smoking_85-89_140-159_150-200': 0.2
    , 'Women_smoking_85-89_140-159_200-250': 0.2
    , 'Women_smoking_85-89_140-159_250<': 0.3

    , 'Women_smoking_85-89_120-139_<150': 0.1
    , 'Women_smoking_85-89_120-139_150-200': 0.2
    , 'Women_smoking_85-89_120-139_200-250': 0.2
    , 'Women_smoking_85-89_120-139_250<': 0.2

    , 'Women_smoking_85-89_100-119_<150': 0.0
    , 'Women_smoking_85-89_100-119_150-200': 0.1
    , 'Women_smoking_85-89_100-119_200-250': 0.1
    , 'Women_smoking_85-89_100-119_250<': 0.1


    , 'Women_smoking_80-84_160-179_<150': 0.2
    , 'Women_smoking_80-84_160-179_150-200': 0.4
    , 'Women_smoking_80-84_160-179_200-250': 0.4
    , 'Women_smoking_80-84_160-179_250<': 0.5

    , 'Women_smoking_80-84_140-159_<150': 0.2
    , 'Women_smoking_80-84_140-159_150-200': 0.3
    , 'Women_smoking_80-84_140-159_200-250': 0.3
    , 'Women_smoking_80-84_140-159_250<': 0.4

    , 'Women_smoking_80-84_120-139_<150': 0.2
    , 'Women_smoking_80-84_120-139_150-200': 0.2
    , 'Women_smoking_80-84_120-139_200-250': 0.3
    , 'Women_smoking_80-84_120-139_250<': 0.2

    , 'Women_smoking_80-84_100-119_<150': 0.1
    , 'Women_smoking_80-84_100-119_150-200': 0.1
    , 'Women_smoking_80-84_100-119_200-250': 0.2
    , 'Women_smoking_80-84_100-119_250<': 0.2


    , 'Women_smoking_75-79_160-179_<150': 0.4
    , 'Women_smoking_75-79_160-179_150-200': 0.5
    , 'Women_smoking_75-79_160-179_200-250': 0.5
    , 'Women_smoking_75-79_160-179_250<': 0.6

    , 'Women_smoking_75-79_140-159_<150': 0.2
    , 'Women_smoking_75-79_140-159_150-200': 0.3
    , 'Women_smoking_75-79_140-159_200-250': 0.5
    , 'Women_smoking_75-79_140-159_250<': 0.5

    , 'Women_smoking_75-79_120-139_<150': 0.2
    , 'Women_smoking_75-79_120-139_150-200': 0.2
    , 'Women_smoking_75-79_120-139_200-250': 0.3
    , 'Women_smoking_75-79_120-139_250<': 0.4

    , 'Women_smoking_75-79_100-119_<150': 0.2
    , 'Women_smoking_75-79_100-119_150-200': 0.2
    , 'Women_smoking_75-79_100-119_200-250': 0.2
    , 'Women_smoking_75-79_100-119_250<': 0.3


    , 'Women_smoking_70-74_160-179_<150': 0.5
    , 'Women_smoking_70-74_160-179_150-200': 0.6
    , 'Women_smoking_70-74_160-179_200-250': 0.7
    , 'Women_smoking_70-74_160-179_250<': 0.8

    , 'Women_smoking_70-74_140-159_<150': 0.4
    , 'Women_smoking_70-74_140-159_150-200': 0.5
    , 'Women_smoking_70-74_140-159_200-250': 0.6
    , 'Women_smoking_70-74_140-159_250<': 0.6

    , 'Women_smoking_70-74_120-139_<150': 0.2
    , 'Women_smoking_70-74_120-139_150-200': 0.3
    , 'Women_smoking_70-74_120-139_200-250': 0.5
    , 'Women_smoking_70-74_120-139_250<': 0.5

    , 'Women_smoking_70-74_100-119_<150': 0.2
    , 'Women_smoking_70-74_100-119_150-200': 0.3
    , 'Women_smoking_70-74_100-119_200-250': 0.3
    , 'Women_smoking_70-74_100-119_250<': 0.3


    , 'Women_smoking_65-69_160-179_<150': 0.6
    , 'Women_smoking_65-69_160-179_150-200': 0.7
    , 'Women_smoking_65-69_160-179_200-250': 0.9
    , 'Women_smoking_65-69_160-179_250<': 0.9

    , 'Women_smoking_65-69_140-159_<150': 0.5
    , 'Women_smoking_65-69_140-159_150-200': 0.6
    , 'Women_smoking_65-69_140-159_200-250': 0.7
    , 'Women_smoking_65-69_140-159_250<': 0.7

    , 'Women_smoking_65-69_120-139_<150': 0.3
    , 'Women_smoking_65-69_120-139_150-200': 0.5
    , 'Women_smoking_65-69_120-139_200-250': 0.5
    , 'Women_smoking_65-69_120-139_250<': 0.6

    , 'Women_smoking_65-69_100-119_<150': 0.3
    , 'Women_smoking_65-69_100-119_150-200': 0.4
    , 'Women_smoking_65-69_100-119_200-250': 0.4
    , 'Women_smoking_65-69_100-119_250<': 0.6


    , 'Women_smoking_60-64_160-179_<150': 0.6
    , 'Women_smoking_60-64_160-179_150-200': 0.8
    , 'Women_smoking_60-64_160-179_200-250': 0.9
    , 'Women_smoking_60-64_160-179_250<': 1.1

    , 'Women_smoking_60-64_140-159_<150': 0.5
    , 'Women_smoking_60-64_140-159_150-200': 0.7
    , 'Women_smoking_60-64_140-159_200-250': 0.8
    , 'Women_smoking_60-64_140-159_250<': 0.9

    , 'Women_smoking_60-64_120-139_<150': 0.4
    , 'Women_smoking_60-64_120-139_150-200': 0.5
    , 'Women_smoking_60-64_120-139_200-250': 0.7
    , 'Women_smoking_60-64_120-139_250<': 0.7

    , 'Women_smoking_60-64_100-119_<150': 0.3
    , 'Women_smoking_60-64_100-119_150-200': 0.4
    , 'Women_smoking_60-64_100-119_200-250': 0.4
    , 'Women_smoking_60-64_100-119_250<': 0.6


    , 'Women_smoking_55-59_160-179_<150': 0.8
    , 'Women_smoking_55-59_160-179_150-200': 1.0
    , 'Women_smoking_55-59_160-179_200-250': 1.1
    , 'Women_smoking_55-59_160-179_250<': 1.2

    , 'Women_smoking_55-59_140-159_<150': 0.6
    , 'Women_smoking_55-59_140-159_150-200': 0.8
    , 'Women_smoking_55-59_140-159_200-250': 0.89
    , 'Women_smoking_55-59_140-159_250<': 1.1

    , 'Women_smoking_55-59_120-139_<150': 0.5
    , 'Women_smoking_55-59_120-139_150-200': 0.6
    , 'Women_smoking_55-59_120-139_200-250': 0.8
    , 'Women_smoking_55-59_120-139_250<': 0.8

    , 'Women_smoking_55-59_100-119_<150': 0.4
    , 'Women_smoking_55-59_100-119_150-200': 0.4
    , 'Women_smoking_55-59_100-119_200-250': 0.6
    , 'Women_smoking_55-59_100-119_250<': 0.6


    , 'Women_smoking_50-54_160-179_<150': 0.9
    , 'Women_smoking_50-54_160-179_150-200': 1.0
    , 'Women_smoking_50-54_160-179_200-250': 1.3
    , 'Women_smoking_50-54_160-179_250<': 1.4

    , 'Women_smoking_50-54_140-159_<150': 0.7
    , 'Women_smoking_50-54_140-159_150-200': 0.9
    , 'Women_smoking_50-54_140-159_200-250': 1.1
    , 'Women_smoking_50-54_140-159_250<': 1.1

    , 'Women_smoking_50-54_120-139_<150': 0.6
    , 'Women_smoking_50-54_120-139_150-200': 0.7
    , 'Women_smoking_50-54_120-139_200-250': 0.8
    , 'Women_smoking_50-54_120-139_250<': 0.9

    , 'Women_smoking_50-54_100-119_<150': 0.4
    , 'Women_smoking_50-54_100-119_150-200': 0.5
    , 'Women_smoking_50-54_100-119_200-250': 0.6
    , 'Women_smoking_50-54_100-119_250<': 0.7


    , 'Women_smoking_45-49_160-179_<150': 0.9
    , 'Women_smoking_45-49_160-179_150-200': 1.1
    , 'Women_smoking_45-49_160-179_200-250': 1.3
    , 'Women_smoking_45-49_160-179_250<': 1.4

    , 'Women_smoking_45-49_140-159_<150': 0.8
    , 'Women_smoking_45-49_140-159_150-200': 0.9
    , 'Women_smoking_45-49_140-159_200-250': 1.1
    , 'Women_smoking_45-49_140-159_250<': 1.2

    , 'Women_smoking_45-49_120-139_<150': 0.6
    , 'Women_smoking_45-49_120-139_150-200': 0.7
    , 'Women_smoking_45-49_120-139_200-250': 0.9
    , 'Women_smoking_45-49_120-139_250<': 0.9

    , 'Women_smoking_45-49_100-119_<150': 0.5
    , 'Women_smoking_45-49_100-119_150-200': 0.6
    , 'Women_smoking_45-49_100-119_200-250': 0.7
    , 'Women_smoking_45-49_100-119_250<': 0.8


    , 'Women_smoking_40-44_160-179_<150': 0.9
    , 'Women_smoking_40-44_160-179_150-200': 1.1
    , 'Women_smoking_40-44_160-179_200-250': 1.3
    , 'Women_smoking_40-44_160-179_250<': 1.4

    , 'Women_smoking_40-44_140-159_<150': 0.8
    , 'Women_smoking_40-44_140-159_150-200': 0.9
    , 'Women_smoking_40-44_140-159_200-250': 1.1
    , 'Women_smoking_40-44_140-159_250<': 1.2

    , 'Women_smoking_40-44_120-139_<150': 0.6
    , 'Women_smoking_40-44_120-139_150-200': 0.8
    , 'Women_smoking_40-44_120-139_200-250': 0.9
    , 'Women_smoking_40-44_120-139_250<': 1.0

    , 'Women_smoking_40-44_100-119_<150': 0.5
    , 'Women_smoking_40-44_100-119_150-200': 0.6
    , 'Women_smoking_40-44_100-119_200-250': 0.7
    , 'Women_smoking_40-44_100-119_250<': 0.8

    , 'Men_nonsmoking_90+_160-179_<150': 0.2
    , 'Men_nonsmoking_90+_160-179_150-200': 0.3
    , 'Men_nonsmoking_90+_160-179_200-250': 0.3
    , 'Men_nonsmoking_90+_160-179_250<': 0.3

    , 'Men_nonsmoking_90+_140-159_<150': 0.2
    , 'Men_nonsmoking_90+_140-159_150-200': 0.2
    , 'Men_nonsmoking_90+_140-159_200-250': 0.2
    , 'Men_nonsmoking_90+_140-159_250<': 0.3

    , 'Men_nonsmoking_90+_120-139_<150': 0.1
    , 'Men_nonsmoking_90+_120-139_150-200': 0.1
    , 'Men_nonsmoking_90+_120-139_200-250': 0.2
    , 'Men_nonsmoking_90+_120-139_250<': 0.2

    , 'Men_nonsmoking_90+_100-119_<150': 0.1
    , 'Men_nonsmoking_90+_100-119_150-200': 0.1
    , 'Men_nonsmoking_90+_100-119_200-250': 0.1
    , 'Men_nonsmoking_90+_100-119_250<': 0.1


    , 'Men_nonsmoking_85-89_160-179_<150': 0.4
    , 'Men_nonsmoking_85-89_160-179_150-200': 0.5
    , 'Men_nonsmoking_85-89_160-179_200-250': 0.5
    , 'Men_nonsmoking_85-89_160-179_250<': 0.5

    , 'Men_nonsmoking_85-89_140-159_<150': 0.3
    , 'Men_nonsmoking_85-89_140-159_150-200': 0.4
    , 'Men_nonsmoking_85-89_140-159_200-250': 0.5
    , 'Men_nonsmoking_85-89_140-159_250<': 0.5

    , 'Men_nonsmoking_85-89_120-139_<150': 0.3
    , 'Men_nonsmoking_85-89_120-139_150-200': 0.4
    , 'Men_nonsmoking_85-89_120-139_200-250': 0.4
    , 'Men_nonsmoking_85-89_120-139_250<': 0.4

    , 'Men_nonsmoking_85-89_100-119_<150': 0.2
    , 'Men_nonsmoking_85-89_100-119_150-200': 0.2
    , 'Men_nonsmoking_85-89_100-119_200-250': 0.3
    , 'Men_nonsmoking_85-89_100-119_250<': 0.3


    , 'Men_nonsmoking_80-84_160-179_<150': 0.5
    , 'Men_nonsmoking_80-84_160-179_150-200': 0.6
    , 'Men_nonsmoking_80-84_160-179_200-250': 0.7
    , 'Men_nonsmoking_80-84_160-179_250<': 0.7

    , 'Men_nonsmoking_80-84_140-159_<150': 0.4
    , 'Men_nonsmoking_80-84_140-159_150-200': 0.5
    , 'Men_nonsmoking_80-84_140-159_200-250': 0.6
    , 'Men_nonsmoking_80-84_140-159_250<': 0.7

    , 'Men_nonsmoking_80-84_120-139_<150': 0.4
    , 'Men_nonsmoking_80-84_120-139_150-200': 0.4
    , 'Men_nonsmoking_80-84_120-139_200-250': 0.5
    , 'Men_nonsmoking_80-84_120-139_250<': 0.5

    , 'Men_nonsmoking_80-84_100-119_<150': 0.2
    , 'Men_nonsmoking_80-84_100-119_150-200': 0.3
    , 'Men_nonsmoking_80-84_100-119_200-250': 0.4
    , 'Men_nonsmoking_80-84_100-119_250<': 0.4


    , 'Men_nonsmoking_75-79_160-179_<150': 0.7
    , 'Men_nonsmoking_75-79_160-179_150-200': 0.8
    , 'Men_nonsmoking_75-79_160-179_200-250': 0.9
    , 'Men_nonsmoking_75-79_160-179_250<': 1.0

    , 'Men_nonsmoking_75-79_140-159_<150': 0.6
    , 'Men_nonsmoking_75-79_140-159_150-200': 0.6
    , 'Men_nonsmoking_75-79_140-159_200-250': 0.7
    , 'Men_nonsmoking_75-79_140-159_250<': 0.9

    , 'Men_nonsmoking_75-79_120-139_<150': 0.4
    , 'Men_nonsmoking_75-79_120-139_150-200': 0.5
    , 'Men_nonsmoking_75-79_120-139_200-250': 0.6
    , 'Men_nonsmoking_75-79_120-139_250<': 0.7

    , 'Men_nonsmoking_75-79_100-119_<150': 0.3
    , 'Men_nonsmoking_75-79_100-119_150-200': 0.4
    , 'Men_nonsmoking_75-79_100-119_200-250': 0.5
    , 'Men_nonsmoking_75-79_100-119_250<': 0.6


    , 'Men_nonsmoking_70-74_160-179_<150': 0.8
    , 'Men_nonsmoking_70-74_160-179_150-200': 0.9
    , 'Men_nonsmoking_70-74_160-179_200-250': 1.1
    , 'Men_nonsmoking_70-74_160-179_250<': 1.1

    , 'Men_nonsmoking_70-74_140-159_<150': 0.7
    , 'Men_nonsmoking_70-74_140-159_150-200': 0.8
    , 'Men_nonsmoking_70-74_140-159_200-250': 1.0
    , 'Men_nonsmoking_70-74_140-159_250<': 1.0

    , 'Men_nonsmoking_70-74_120-139_<150': 0.5
    , 'Men_nonsmoking_70-74_120-139_150-200': 0.6
    , 'Men_nonsmoking_70-74_120-139_200-250': 0.7
    , 'Men_nonsmoking_70-74_120-139_250<': 0.9

    , 'Men_nonsmoking_70-74_100-119_<150': 0.4
    , 'Men_nonsmoking_70-74_100-119_150-200': 0.5
    , 'Men_nonsmoking_70-74_100-119_200-250': 0.6
    , 'Men_nonsmoking_70-74_100-119_250<': 0.6


    , 'Men_nonsmoking_65-69_160-179_<150': 0.9
    , 'Men_nonsmoking_65-69_160-179_150-200': 1.1
    , 'Men_nonsmoking_65-69_160-179_200-250': 1.2
    , 'Men_nonsmoking_65-69_160-179_250<': 1.3

    , 'Men_nonsmoking_65-69_140-159_<150': 0.8
    , 'Men_nonsmoking_65-69_140-159_150-200': 1.0
    , 'Men_nonsmoking_65-69_140-159_200-250': 1.0
    , 'Men_nonsmoking_65-69_140-159_250<': 1.1

    , 'Men_nonsmoking_65-69_120-139_<150': 0.6
    , 'Men_nonsmoking_65-69_120-139_150-200': 0.8
    , 'Men_nonsmoking_65-69_120-139_200-250': 0.8
    , 'Men_nonsmoking_65-69_120-139_250<': 1.0

    , 'Men_nonsmoking_65-69_100-119_<150': 0.5
    , 'Men_nonsmoking_65-69_100-119_150-200': 0.7
    , 'Men_nonsmoking_65-69_100-119_200-250': 0.7
    , 'Men_nonsmoking_65-69_100-119_250<': 0.8


    , 'Men_nonsmoking_60-64_160-179_<150': 1.1
    , 'Men_nonsmoking_60-64_160-179_150-200': 1.2
    , 'Men_nonsmoking_60-64_160-179_200-250': 1.4
    , 'Men_nonsmoking_60-64_160-179_250<': 1.4

    , 'Men_nonsmoking_60-64_140-159_<150': 0.8
    , 'Men_nonsmoking_60-64_140-159_150-200': 1.0
    , 'Men_nonsmoking_60-64_140-159_200-250': 1.2
    , 'Men_nonsmoking_60-64_140-159_250<': 1.2

    , 'Men_nonsmoking_60-64_120-139_<150': 0.7
    , 'Men_nonsmoking_60-64_120-139_150-200': 0.8
    , 'Men_nonsmoking_60-64_120-139_200-250': 1.0
    , 'Men_nonsmoking_60-64_120-139_250<': 1.1

    , 'Men_nonsmoking_60-64_100-119_<150': 0.5
    , 'Men_nonsmoking_60-64_100-119_150-200': 0.7
    , 'Men_nonsmoking_60-64_100-119_200-250': 0.7
    , 'Men_nonsmoking_60-64_100-119_250<': 0.8


    , 'Men_nonsmoking_55-59_160-179_<150': 1.1
    , 'Men_nonsmoking_55-59_160-179_150-200': 1.3
    , 'Men_nonsmoking_55-59_160-179_200-250': 1.4
    , 'Men_nonsmoking_55-59_160-179_250<': 1.6

    , 'Men_nonsmoking_55-59_140-159_<150': 0.9
    , 'Men_nonsmoking_55-59_140-159_150-200': 1.1
    , 'Men_nonsmoking_55-59_140-159_200-250': 1.3
    , 'Men_nonsmoking_55-59_140-159_250<': 1.4

    , 'Men_nonsmoking_55-59_120-139_<150': 0.7
    , 'Men_nonsmoking_55-59_120-139_150-200': 0.9
    , 'Men_nonsmoking_55-59_120-139_200-250': 1.1
    , 'Men_nonsmoking_55-59_120-139_250<': 1.2

    , 'Men_nonsmoking_55-59_100-119_<150': 0.6
    , 'Men_nonsmoking_55-59_100-119_150-200': 0.6
    , 'Men_nonsmoking_55-59_100-119_200-250': 0.8
    , 'Men_nonsmoking_55-59_100-119_250<': 0.9


    , 'Men_nonsmoking_50-54_160-179_<150': 1.2
    , 'Men_nonsmoking_50-54_160-179_150-200': 1.4
    , 'Men_nonsmoking_50-54_160-179_200-250': 1.5
    , 'Men_nonsmoking_50-54_160-179_250<': 1.6

    , 'Men_nonsmoking_50-54_140-159_<150': 1.0
    , 'Men_nonsmoking_50-54_140-159_150-200': 1.2
    , 'Men_nonsmoking_50-54_140-159_200-250': 1.3
    , 'Men_nonsmoking_50-54_140-159_250<': 1.5

    , 'Men_nonsmoking_50-54_120-139_<150': 0.8
    , 'Men_nonsmoking_50-54_120-139_150-200': 1.0
    , 'Men_nonsmoking_50-54_120-139_200-250': 1.1
    , 'Men_nonsmoking_50-54_120-139_250<': 1.2

    , 'Men_nonsmoking_50-54_100-119_<150': 0.6
    , 'Men_nonsmoking_50-54_100-119_150-200': 0.7
    , 'Men_nonsmoking_50-54_100-119_200-250': 0.9
    , 'Men_nonsmoking_50-54_100-119_250<': 1.0


    , 'Men_nonsmoking_45-49_160-179_<150': 1.2
    , 'Men_nonsmoking_45-49_160-179_150-200': 1.4
    , 'Men_nonsmoking_45-49_160-179_200-250': 1.6
    , 'Men_nonsmoking_45-49_160-179_250<': 1.6

    , 'Men_nonsmoking_45-49_140-159_<150': 1.0
    , 'Men_nonsmoking_45-49_140-159_150-200': 1.2
    , 'Men_nonsmoking_45-49_140-159_200-250': 1.4
    , 'Men_nonsmoking_45-49_140-159_250<': 1.5

    , 'Men_nonsmoking_45-49_120-139_<150': 0.8
    , 'Men_nonsmoking_45-49_120-139_150-200': 1.0
    , 'Men_nonsmoking_45-49_120-139_200-250': 1.1
    , 'Men_nonsmoking_45-49_120-139_250<': 1.3

    , 'Men_nonsmoking_45-49_100-119_<150': 0.6
    , 'Men_nonsmoking_45-49_100-119_150-200': 0.8
    , 'Men_nonsmoking_45-49_100-119_200-250': 0.9
    , 'Men_nonsmoking_45-49_100-119_250<': 1.0


    , 'Men_nonsmoking_40-44_160-179_<150': 1.3
    , 'Men_nonsmoking_40-44_160-179_150-200': 1.4
    , 'Men_nonsmoking_40-44_160-179_200-250': 1.6
    , 'Men_nonsmoking_40-44_160-179_250<': 1.6

    , 'Men_nonsmoking_40-44_140-159_<150': 1.0
    , 'Men_nonsmoking_40-44_140-159_150-200': 1.2
    , 'Men_nonsmoking_40-44_140-159_200-250': 1.4
    , 'Men_nonsmoking_40-44_140-159_250<': 1.5

    , 'Men_nonsmoking_40-44_120-139_<150': 0.8
    , 'Men_nonsmoking_40-44_120-139_150-200': 1.0
    , 'Men_nonsmoking_40-44_120-139_200-250': 1.1
    , 'Men_nonsmoking_40-44_120-139_250<': 1.3

    , 'Men_nonsmoking_40-44_100-119_<150': 0.6
    , 'Men_nonsmoking_40-44_100-119_150-200': 0.8
    , 'Men_nonsmoking_40-44_100-119_200-250': 0.9
    , 'Men_nonsmoking_40-44_100-119_250<': 1.0

    , 'Men_smoking_90+_160-179_<150': 0.1
    , 'Men_smoking_90+_160-179_150-200': 0.0
    , 'Men_smoking_90+_160-179_200-250': 0.1
    , 'Men_smoking_90+_160-179_250<': 0.1

    , 'Men_smoking_90+_140-159_<150': 0.0
    , 'Men_smoking_90+_140-159_150-200': 0.0
    , 'Men_smoking_90+_140-159_200-250': 0.0
    , 'Men_smoking_90+_140-159_250<': 0.0

    , 'Men_smoking_90+_120-139_<150': 0.1
    , 'Men_smoking_90+_120-139_150-200': 0.0
    , 'Men_smoking_90+_120-139_200-250': 0.0
    , 'Men_smoking_90+_120-139_250<': 0.1

    , 'Men_smoking_90+_100-119_<150': 0.0
    , 'Men_smoking_90+_100-119_150-200': 0.1
    , 'Men_smoking_90+_100-119_200-250': 0.0
    , 'Men_smoking_90+_100-119_250<': 0.1


    , 'Men_smoking_85-89_160-179_<150': 0.1
    , 'Men_smoking_85-89_160-179_150-200': 0.1
    , 'Men_smoking_85-89_160-179_200-250': 0.1
    , 'Men_smoking_85-89_160-179_250<': 0.2

    , 'Men_smoking_85-89_140-159_<150': 0.1
    , 'Men_smoking_85-89_140-159_150-200': 0.1
    , 'Men_smoking_85-89_140-159_200-250': 0.1
    , 'Men_smoking_85-89_140-159_250<': 0.1

    , 'Men_smoking_85-89_120-139_<150': 0.0
    , 'Men_smoking_85-89_120-139_150-200': 0.0
    , 'Men_smoking_85-89_120-139_200-250': 0.01
    , 'Men_smoking_85-89_120-139_250<': 0.1

    , 'Men_smoking_85-89_100-119_<150': 0.0
    , 'Men_smoking_85-89_100-119_150-200': 0.0
    , 'Men_smoking_85-89_100-119_200-250': 0.0
    , 'Men_smoking_85-89_100-119_250<': 0.1


    , 'Men_smoking_80-84_160-179_<150': 0.1
    , 'Men_smoking_80-84_160-179_150-200': 0.2
    , 'Men_smoking_80-84_160-179_200-250': 0.2
    , 'Men_smoking_80-84_160-179_250<': 0.2

    , 'Men_smoking_80-84_140-159_<150': 0.1
    , 'Men_smoking_80-84_140-159_150-200': 0.1
    , 'Men_smoking_80-84_140-159_200-250': 0.2
    , 'Men_smoking_80-84_140-159_250<': 0.2

    , 'Men_smoking_80-84_120-139_<150': 0.0
    , 'Men_smoking_80-84_120-139_150-200': 0.1
    , 'Men_smoking_80-84_120-139_200-250': 0.1
    , 'Men_smoking_80-84_120-139_250<': 0.1

    , 'Men_smoking_80-84_100-119_<150': 0.0
    , 'Men_smoking_80-84_100-119_150-200': 0.0
    , 'Men_smoking_80-84_100-119_200-250': 0.0
    , 'Men_smoking_80-84_100-119_250<': 0.1


    , 'Men_smoking_75-79_160-179_<150': 0.2
    , 'Men_smoking_75-79_160-179_150-200': 0.2
    , 'Men_smoking_75-79_160-179_200-250': 0.3
    , 'Men_smoking_75-79_160-179_250<': 0.3

    , 'Men_smoking_75-79_140-159_<150': 0.2
    , 'Men_smoking_75-79_140-159_150-200': 0.2
    , 'Men_smoking_75-79_140-159_200-250': 0.3
    , 'Men_smoking_75-79_140-159_250<': 0.3

    , 'Men_smoking_75-79_120-139_<150': 0.1
    , 'Men_smoking_75-79_120-139_150-200': 0.2
    , 'Men_smoking_75-79_120-139_200-250': 0.2
    , 'Men_smoking_75-79_120-139_250<': 0.2

    , 'Men_smoking_75-79_100-119_<150': 0.1
    , 'Men_smoking_75-79_100-119_150-200': 0.1
    , 'Men_smoking_75-79_100-119_200-250': 0.2
    , 'Men_smoking_75-79_100-119_250<': 0.1


    , 'Men_smoking_70-74_160-179_<150': 0.3
    , 'Men_smoking_70-74_160-179_150-200': 0.4
    , 'Men_smoking_70-74_160-179_200-250': 0.5
    , 'Men_smoking_70-74_160-179_250<': 0.5

    , 'Men_smoking_70-74_140-159_<150': 0.2
    , 'Men_smoking_70-74_140-159_150-200': 0.3
    , 'Men_smoking_70-74_140-159_200-250': 0.4
    , 'Men_smoking_70-74_140-159_250<': 0.4

    , 'Men_smoking_70-74_120-139_<150': 0.2
    , 'Men_smoking_70-74_120-139_150-200': 0.2
    , 'Men_smoking_70-74_120-139_200-250': 0.3
    , 'Men_smoking_70-74_120-139_250<': 0.4

    , 'Men_smoking_70-74_100-119_<150': 0.1
    , 'Men_smoking_70-74_100-119_150-200': 0.2
    , 'Men_smoking_70-74_100-119_200-250': 0.3
    , 'Men_smoking_70-74_100-119_250<': 0.2


    , 'Men_smoking_65-69_160-179_<150': 0.5
    , 'Men_smoking_65-69_160-179_150-200': 0.5
    , 'Men_smoking_65-69_160-179_200-250': 0.7
    , 'Men_smoking_65-69_160-179_250<': 0.7

    , 'Men_smoking_65-69_140-159_<150': 0.4
    , 'Men_smoking_65-69_140-159_150-200': 0.5
    , 'Men_smoking_65-69_140-159_200-250': 0.5
    , 'Men_smoking_65-69_140-159_250<': 0.6

    , 'Men_smoking_65-69_120-139_<150': 0.3
    , 'Men_smoking_65-69_120-139_150-200': 0.4
    , 'Men_smoking_65-69_120-139_200-250': 0.4
    , 'Men_smoking_65-69_120-139_250<': 0.4

    , 'Men_smoking_65-69_100-119_<150': 0.3
    , 'Men_smoking_65-69_100-119_150-200': 0.4
    , 'Men_smoking_65-69_100-119_200-250': 0.5
    , 'Men_smoking_65-69_100-119_250<': 0.4


    , 'Men_smoking_60-64_160-179_<150': 1.1
    , 'Men_smoking_60-64_160-179_150-200': 1.2
    , 'Men_smoking_60-64_160-179_200-250': 1.4
    , 'Men_smoking_60-64_160-179_250<': 1.4

    , 'Men_smoking_60-64_140-159_<150': 0.8
    , 'Men_smoking_60-64_140-159_150-200': 1.0
    , 'Men_smoking_60-64_140-159_200-250': 1.2
    , 'Men_smoking_60-64_140-159_250<': 1.2

    , 'Men_smoking_60-64_120-139_<150': 0.7
    , 'Men_smoking_60-64_120-139_150-200': 0.8
    , 'Men_smoking_60-64_120-139_200-250': 1.0
    , 'Men_smoking_60-64_120-139_250<': 1.1

    , 'Men_smoking_60-64_100-119_<150': 0.5
    , 'Men_smoking_60-64_100-119_150-200': 0.7
    , 'Men_smoking_60-64_100-119_200-250': 0.7
    , 'Men_smoking_60-64_100-119_250<': 0.8


    , 'Men_smoking_55-59_160-179_<150': 0.8
    , 'Men_smoking_55-59_160-179_150-200': 0.9
    , 'Men_smoking_55-59_160-179_200-250': 1.0
    , 'Men_smoking_55-59_160-179_250<': 1.1

    , 'Men_smoking_55-59_140-159_<150': 0.6
    , 'Men_smoking_55-59_140-159_150-200': 0.7
    , 'Men_smoking_55-59_140-159_200-250': 0.8
    , 'Men_smoking_55-59_140-159_250<': 0.9

    , 'Men_smoking_55-59_120-139_<150': 0.4
    , 'Men_smoking_55-59_120-139_150-200': 0.6
    , 'Men_smoking_55-59_120-139_200-250': 0.7
    , 'Men_smoking_55-59_120-139_250<': 0.8

    , 'Men_smoking_55-59_100-119_<150': 0.3
    , 'Men_smoking_55-59_100-119_150-200': 0.5
    , 'Men_smoking_55-59_100-119_200-250': 0.5
    , 'Men_smoking_55-59_100-119_250<': 0.6


    , 'Men_smoking_50-54_160-179_<150': 0.9
    , 'Men_smoking_50-54_160-179_150-200': 1.0
    , 'Men_smoking_50-54_160-179_200-250': 1.2
    , 'Men_smoking_50-54_160-179_250<': 1.3

    , 'Men_smoking_50-54_140-159_<150': 0.7
    , 'Men_smoking_50-54_140-159_150-200': 0.8
    , 'Men_smoking_50-54_140-159_200-250': 0.9
    , 'Men_smoking_50-54_140-159_250<': 1.1

    , 'Men_smoking_50-54_120-139_<150': 0.6
    , 'Men_smoking_50-54_120-139_150-200': 0.7
    , 'Men_smoking_50-54_120-139_200-250': 0.7
    , 'Men_smoking_50-54_120-139_250<': 0.8

    , 'Men_smoking_50-54_100-119_<150': 0.4
    , 'Men_smoking_50-54_100-119_150-200': 0.5
    , 'Men_smoking_50-54_100-119_200-250': 0.6
    , 'Men_smoking_50-54_100-119_250<': 0.6


    , 'Men_smoking_45-49_160-179_<150': 0.9
    , 'Men_smoking_45-49_160-179_150-200': 1.1
    , 'Men_smoking_45-49_160-179_200-250': 1.3
    , 'Men_smoking_45-49_160-179_250<': 1.4

    , 'Men_smoking_45-49_140-159_<150': 0.7
    , 'Men_smoking_45-49_140-159_150-200': 0.9
    , 'Men_smoking_45-49_140-159_200-250': 1.1
    , 'Men_smoking_45-49_140-159_250<': 1.2

    , 'Men_smoking_45-49_120-139_<150': 0.6
    , 'Men_smoking_45-49_120-139_150-200': 0.7
    , 'Men_smoking_45-49_120-139_200-250': 0.9
    , 'Men_smoking_45-49_120-139_250<': 0.9

    , 'Men_smoking_45-49_100-119_<150': 0.5
    , 'Men_smoking_45-49_100-119_150-200': 0.6
    , 'Men_smoking_45-49_100-119_200-250': 0.6
    , 'Men_smoking_45-49_100-119_250<': 0.8


    , 'Men_smoking_40-44_160-179_<150': 0.9
    , 'Men_smoking_40-44_160-179_150-200': 1.2
    , 'Men_smoking_40-44_160-179_200-250': 1.4
    , 'Men_smoking_40-44_160-179_250<': 1.5

    , 'Men_smoking_40-44_140-159_<150': 0.8
    , 'Men_smoking_40-44_140-159_150-200': 0.9
    , 'Men_smoking_40-44_140-159_200-250': 1.1
    , 'Men_smoking_40-44_140-159_250<': 1.3

    , 'Men_smoking_40-44_120-139_<150': 0.6
    , 'Men_smoking_40-44_120-139_150-200': 0.8
    , 'Men_smoking_40-44_120-139_200-250': 0.9
    , 'Men_smoking_40-44_120-139_250<': 1.0

    , 'Men_smoking_40-44_100-119_<150': 0.5
    , 'Men_smoking_40-44_100-119_150-200': 0.6
    , 'Men_smoking_40-44_100-119_200-250': 0.7
    , 'Men_smoking_40-44_100-119_250<': 0.8
};

/**
 * Convert systolic blood pressure value to range string
 */
export function sysVal(n: number): string {
    n = parseInt(n.toString());
    if (n >= 100 && n <= 119) {
        return "100-119";
    }
    if (n >= 120 && n <= 139) {
        return "120-139";
    }
    if (n >= 140 && n <= 159) {
        return "140-159";
    }
    if (n >= 160) {
        return "160-179";
    }
    return "100-119"; // default
}

/**
 * Convert cholesterol value to range string
 */
export function cholVal(n: number): string {
    n = parseInt(n.toString());
    if (n < 150) {
        return "<150";
    }
    if (n >= 150 && n <= 200) {
        return "150-200";
    }
    if (n >= 200 && n <= 250) {
        return "200-250";
    }
    if (n > 250) {
        return "250<";
    }
    return "150-200"; // default
}

/**
 * Calculate years gained based on intervention type
 */
export function calculate(value: number, key: string, type: 'smoke' | 'systolic blood pressure reduction' | 'LDL-C reduction'): number {
    let years = 0;

    if (type === "systolic blood pressure reduction") {
        const database = calcSystolic;
        while (value > 120) {
            const s = sysVal(value);
            const newKey = key.split('_');
            newKey[3] = s;
            const updatedKey = newKey.join('_');
            const dbValue = database[updatedKey];
            if (dbValue !== undefined && dbValue !== -1) {
                years += dbValue;
            }
            value -= 10;
        }
    } else if (type === "LDL-C reduction") {
        const database = calcLdlc;
        const TARGET = 100;
        while (value > TARGET) {
            const s = cholVal(value);
            const newKey = key.split('_');
            newKey[newKey.length - 1] = s;
            const updatedKey = newKey.join('_');
            const dbValue = database[updatedKey];

            if (dbValue !== undefined) {
                if (value - 40 >= TARGET) {
                    years += dbValue;
                } else if (value - 40 < TARGET) {
                    const coef = (value - TARGET) / 40;
                    years += (dbValue * coef);
                }
            }
            value -= 40;
        }
    } else if (type === "smoke") {
        const newKey = key.split("_");
        const smokeKey = [newKey[0]].concat(newKey.slice(2)).join("_");
        const dbValue = calcSmoke[smokeKey];
        if (dbValue !== undefined) {
            years = dbValue;
        }
    }

    return years;
}

/**
 * Main calculation function for life years gained
 */
export function calculateLifeYears(
    gender: 'female' | 'male',
    age: number,
    smoking: 'yes' | 'no',
    systolic: number,
    cholesterol: number
): CalculationResult {
    try {
        // Convert frontend values to backend format
        const genderKey = gender === 'female' ? 'Women' : 'Men';
        const smokingKey = smoking === 'yes' ? 'smoking' : 'nonsmoking';

        // Convert age to age range
        const ageRanges: Record<number, string> = {
            40: '40-44', 41: '40-44', 42: '40-44', 43: '40-44', 44: '40-44',
            45: '45-49', 46: '45-49', 47: '45-49', 48: '45-49', 49: '45-49',
            50: '50-54', 51: '50-54', 52: '50-54', 53: '50-54', 54: '50-54',
            55: '55-59', 56: '55-59', 57: '55-59', 58: '55-59', 59: '55-59',
            60: '60-64', 61: '60-64', 62: '60-64', 63: '60-64', 64: '60-64',
            65: '65-69', 66: '65-69', 67: '65-69', 68: '65-69', 69: '65-69',
            70: '70-74', 71: '70-74', 72: '70-74', 73: '70-74', 74: '70-74',
            75: '75-79', 76: '75-79', 77: '75-79', 78: '75-79', 79: '75-79',
            80: '80-84', 81: '80-84', 82: '80-84', 83: '80-84', 84: '80-84',
            85: '85-89', 86: '85-89', 87: '85-89', 88: '85-89', 89: '85-89',
            90: '90+', 91: '90+', 92: '90+', 93: '90+', 94: '90+', 95: '90+'
        };
        const ageRange = ageRanges[age] || '60-64';
        // Create the key for lookup
        const key = `${genderKey}_${smokingKey}_${ageRange}_${sysVal(systolic)}_${cholVal(cholesterol)}`;

        // Calculate years gained for each intervention
        const smokeYears = smoking === 'yes' ? calculate(0, key, 'smoke') : 0;
        const systolicYears = calculate(systolic, key, 'systolic blood pressure reduction');
        const cholesterolYears = calculate(cholesterol, key, 'LDL-C reduction');

        // Create interventions list
        const interventions: Intervention[] = [
            { name: 'הפסקת עישון', years: smokeYears, type: 'smoking' },
            { name: 'הורדת לחץ דם', years: systolicYears, type: 'systolic' },
            { name: 'הורדת כולסטרול', years: cholesterolYears, type: 'cholesterol' }
        ];

        // Sort by years gained (descending)
        interventions.sort((a, b) => b.years - a.years);

        // Calculate total years from only non-zero interventions (those that will be displayed)
        // Sum the raw years values directly (no intermediate rounding) to match individual display logic
        // The rounding will happen at display time, ensuring consistency
        const visibleInterventions = interventions.filter(i => (i.years ?? 0) > 0);
        const totalYears = visibleInterventions.reduce((sum, i) => sum + (i.years ?? 0), 0);

        return {
            success: true,
            interventions: interventions,
            total_years: totalYears,
            input_data: {
                gender,
                age,
                smoking,
                systolic,
                cholesterol
            },
            results: { smokeYears, systolicYears, cholesterolYears },
            // resultIdentifier: generateRandomCode()
        };
    } catch (error) {
        return {
            success: false,
            interventions: [],
            total_years: 0,
            input_data: { gender, age, smoking, systolic, cholesterol },
            error: error instanceof Error ? error.message : 'Unknown error'
        };
    }
}

/**
 * Validate input parameters
 */
export function validateInput(gender: string, age: number, smoking: string, systolic: number, cholesterol: number): boolean {
    // Validate gender
    if (!['female', 'male'].includes(gender)) {
        return false;
    }

    // Validate age
    if (!Number.isInteger(age) || age < 40 || age > 90) {
        return false;
    }

    // Validate smoking
    if (!['yes', 'no'].includes(smoking)) {
        return false;
    }

    // Validate systolic blood pressure
    if (typeof systolic !== 'number' || systolic === 0 || systolic < 80 || systolic > 300) {
        return false;
    }

    // Validate cholesterol
    if (typeof cholesterol !== 'number' || cholesterol === 0 || cholesterol < 50 || cholesterol > 500) {
        return false;
    }

    return true;
}
